import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { createPortal } from "react-dom";
//import videoBackground from "./Assets/Wallpaper.png";
import { FaVolumeMute, FaVolumeUp } from "react-icons/fa";
import TopBar from "./TopBar";
import Login from "./Try/Login";
import coinsImg from "./Assets/Coin.jpg.png";
import shoop from "./Assets/Xianhe New Assets/mainpage/mainpage-shop.png";
import shopbg from "./Assets/Xianhe New Assets/mainpage/bg-mainpage-video.png";
import hands from "./Assets/Xianhe New Assets/mainpage/hands.png";
import clock from "./Assets/Xianhe New Assets/mainpage/clock.png";
import google from "./Assets/google.jpg";
// import xianhe from "./Assets/logo_black.png";
// import xianheLogo2 from "./Assets/newlogo.png";
// import xianheLogo2 from "./Assets/logo_goldenlf.png";
// import xianhe from "./Assets/logo_lotus_fairy.jpg";
// import xianheLogo2 from "./Assets/xianheLogo2.png";
import serviceBorder from "./Assets/serviceBorder.png";
import { FaApple } from "react-icons/fa";
import { signInWithGooglePopup } from "../utils/firebase.utils";
import { getAuth, OAuthProvider, signInWithPopup } from "firebase/auth";
import XianheModal from "./Visitor/NewUser";
import Visitor from "./Visitor/VisitorPage";
import ElementFinder from "./Visitor/ElementFinder";
import AboutPage from "./AboutPage";

import Footer from "./Try/Footer.jsx";
// import animatedFairy from "./Assets/animatedFairy.mp4";
// import animatedFairy from "./Assets/Viedo.mp4";
// import animatedFairy from "./Assets/Viedo1.mp4";
import animatedFairy from "./Assets/newvideo.mp4";
import bgvideo from "./Assets/Xianhe New Assets/mainpage/mainpage-landingbg.mp4";
import animatedCardsGif from "./Assets/Xianhe New Assets/mainpage/mainpage-cards.gif";
import animatedCardsWebm from "./Assets/Xianhe New Assets/mainpage/mainpage-landingcards-webm.webm";

import { useTranslation } from 'react-i18next';
import globeIcon from "./Assets/globe.png";
import { fetchLanguages } from '../i18n'; // Add this import
import { syncProfileLanguageFromGetProfile } from "../utils/profileLanguageSync";

import AmuletShowcase from "./AmuletShowcase";
//import masterBackground from "./Assets/master_image_bg.png";
// import both desktop & mobile background videos (choose at runtime)
// import videoBackgroundDesktop from "./Assets/bgMaster.mp4";
import masterBackground from "./Assets/master2.jpg";
import fairyImage from "./Assets/fairyImage.png";
import bigStar from "./Assets/bigStar.png";
import backgroundStars from "./Assets/backgroundStars.png";
import videoBackgroundDesktop from "./Assets/bgVideoMaster1.mp4";
import videoBackgroundMobile from "./Assets/bgMasterMobile.mp4";
//import introVideo from "./Assets/introvideo.mp4";
import introVideo from "./Assets/Xianhe New Assets/mainpage/mainpage-video.mp4";

import highlights1 from "./Assets/highlights/1.jpeg";
import highlights2 from "./Assets/highlights/2.jpeg";
import highlights3 from "./Assets/highlights/3.jpeg";
import highlights4 from "./Assets/highlights/4.jpeg";
import highlights5 from "./Assets/highlights/5.jpeg";
import highlights6 from "./Assets/highlights/6.jpeg";
import highlights7 from "./Assets/highlights/7.jpeg";
import amulet1 from "./Assets/amulet.png";
import amulet2 from "./Assets/amulet.png";
import amulet3 from "./Assets/amulet.png";
import amulet4 from "./Assets/amulet.png";
import amulet5 from "./Assets/amulet.png";
import amulet6 from "./Assets/amulet.png";
import amulet7 from "./Assets/amulet.png";
import amulet8 from "./Assets/amulet.png";
import amulet9 from "./Assets/amulet.png";
import amulet10 from "./Assets/amulet.png";
import amulet11 from "./Assets/amulet.png";
import LandingpageTray from "./LandingpageTray.jsx";
import OurServices from "./OurServices.jsx";
import { gsap } from "gsap"; //GreenSock Animation Platform (GSAP) - used this for subheading typewriter effect
import { TextPlugin } from "gsap/TextPlugin";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import image1 from "./Assets/Questions/mountain.png";
import image2 from "./Assets/Questions/soil.png";
import image3 from "./Assets/Questions/sun.png";
import image4 from "./Assets/Questions/candle_flame.png";
import image5 from "./Assets/Questions/Axe.png";
import image6 from "./Assets/Questions/jewellery.png";
import image7 from "./Assets/Questions/The_tree.png";
import image8 from "./Assets/Questions/The_Flower.png";
import image9 from "./Assets/Questions/Ocean.png";
import image10 from "./Assets/Questions/rain_water.png";
import zodiac1 from "./Assets/Zodiac/dog.png";
import zodiac2 from "./Assets/Zodiac/dragon.png";
import zodiac3 from "./Assets/Zodiac/goat.png";
import zodiac4 from "./Assets/Zodiac/horse.png";
import zodiac5 from "./Assets/Zodiac/monkey.png";
import zodiac6 from "./Assets/Zodiac/ox.png";
import zodiac7 from "./Assets/Zodiac/pig.png";
import zodiac8 from "./Assets/Zodiac/rabbit.png";
import zodiac9 from "./Assets/Zodiac/rat.png";
import zodiac10 from "./Assets/Zodiac/rooster.png";
import zodiac11 from "./Assets/Zodiac/snake.png";
import zodiac12 from "./Assets/Zodiac/tiger.png";


function MainPage() {
  const [isMuted, setIsMuted] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [name, setName] = useState("");
  const [showSignInModal, setShowSignInModal] = useState(false);
  const [showEmailSignInModal, setShowEmailSignInModal] = useState(false);
  const [showCollectAmuletLoginModal, setShowCollectAmuletLoginModal] = useState(false);
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [isModal, setIsModal] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", message: "" });
  // videoRef removed; using static image for the right-side artwork
  const location = useLocation();
  const navigate = useNavigate();
  const userID = localStorage.getItem("userID");

  // If another page set openLoginPanel flag, open login panel on mount
  useEffect(() => {
    try {
      const openFlag = localStorage.getItem('openLoginPanel');
      if (openFlag === 'true') {
        setIsLoginPanelOpen(true);
        localStorage.removeItem('openLoginPanel');
      }
    } catch (e) {}
  }, []);

  // Cart & gems state (used by TopBar dropdown)
  const [cartItemCount, setCartItemCount] = useState(0);
  const [coins, setCoins] = useState(0);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isLoginPanelOpen, setIsLoginPanelOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Intro video state
  const [showIntro, setShowIntro] = useState(true);
  const introRef = useRef(null);
  const [isIntroMuted, setIsIntroMuted] = useState(true);

  const [showElementFinderModal, setShowElementFinderModal] = useState(false);
  const headingRef = useRef(null);
  // Ref that wraps the heading + subheadings + button we want the modal to cover
  const elementRegionRef = useRef(null);
  const [headingWidth, setHeadingWidth] = useState(null);
  const typeRef = useRef(null);

  // Measured bounding rect in viewport coordinates for the element region
  const [elementRect, setElementRect] = useState(null);

  const [selectedMonth, setSelectedMonth] = useState("5"); // May (1-based)
  const [selectedDay, setSelectedDay] = useState("21");
  const [selectedYear, setSelectedYear] = useState("2000");
  const [elementFinderResult, setElementFinderResult] = useState(null);
  const [elementFinderResult_DO_NOT_SHOW, setElementFinderResult_DO_NOT_SHOW] = useState(null);
  const [showElementResult, setShowElementResult] = useState(false);
  const [zodiacDescriptions, setZodiacDescriptions] = useState({});

  const [zodiacName, setZodiacName] = useState("");
  const [zodiacSign, setZodiacSign] = useState("");
  const [showZodiacTooltip, setShowZodiacTooltip] = useState(false);
  const [zodiacName2, setZodiacName2] = useState("");
  const [zodiacSign2, setZodiacSign2] = useState("");
  const [showZodiacTooltip2, setShowZodiacTooltip2] = useState(false);

  const [siteContent, setSiteContent] = useState({});

  const [showAppointmentsDropdown, setShowAppointmentsDropdown] = useState(false);
  const [showDestinyDropdown, setShowDestinyDropdown] = useState(false);

  const handleAppointmentsMouseEnter = () => setShowAppointmentsDropdown(true);
  const handleAppointmentsMouseLeave = () => setShowAppointmentsDropdown(false);
  const handleDestinyMouseEnter = () => setShowDestinyDropdown(true);
  const handleDestinyMouseLeave = () => setShowDestinyDropdown(false);

  const videoRef = useRef(null);
  const bgVideoRef = useRef(null);
  const [showPlayOverlay, setShowPlayOverlay] = useState(true);
  const heroCardsContainerRef = useRef(null);
  const heroCardsVideoRef = useRef(null);
  const heroCardsHoveredRef = useRef(false);
  const heroCardsPlayedOnceRef = useRef(false);
  const [isHeroCardsVideoReady, setIsHeroCardsVideoReady] = useState(false);
  const [useHeroCardsGifFallback, setUseHeroCardsGifFallback] = useState(false);
  const isSafariBrowser = useMemo(() => {
    const userAgent = navigator.userAgent;
    return /Safari/i.test(userAgent) && !/Chrome|Chromium|CriOS|FxiOS|EdgiOS|OPiOS|Android/i.test(userAgent);
  }, []);

  const { t, i18n } = useTranslation();
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem('language') || 'en'
  );
  const [availableLanguages, setAvailableLanguages] = useState([]); // Add this

  // Derive the backend LangId from the currently selected language code.
  // This prevents mismatches where UI language is English but API content is fetched in Bahasa (or vice versa).
  const effectiveLanguageId = useMemo(() => {
    const normalizedCode = (selectedLanguage || 'en').toLowerCase();

    const matched = availableLanguages.find((lang) => {
      const detail = (lang.LookupDetail || '').toString();
      const langCode = detail.match(/^(\S+)/)?.[1]?.toLowerCase() || '';
      return langCode === normalizedCode;
    });

    const matchedId = matched?.Id ?? matched?.id;
    if (typeof matchedId === 'number' && Number.isFinite(matchedId)) return String(matchedId);
    if (typeof matchedId === 'string' && matchedId.trim()) return matchedId.trim();

    // Fallback mapping (based on API language data)
    // - 2224: English (EN)
    // - 2225: Bahasa (ID)
    // - 2226: Chinese (ZH-CN)
    return normalizedCode === 'en' ? '2224' : normalizedCode === 'id' ? '2225' : normalizedCode === 'cn' ? '2226' : '2224';
  }, [availableLanguages, selectedLanguage]);

  // Keep localStorage in sync so other pages/components that still read `languageId` don't drift.
  useEffect(() => {
    if (effectiveLanguageId) {
      localStorage.setItem('languageId', effectiveLanguageId);
    }
  }, [effectiveLanguageId]);

  useEffect(() => {
    if (!isSafariBrowser) return;
    setUseHeroCardsGifFallback(true);
    setIsHeroCardsVideoReady(false);
  }, [isSafariBrowser]);

  const handlePlayClick = () => {
    if (videoRef.current) {
      videoRef.current.muted = false;
      videoRef.current.play();
      setShowPlayOverlay(false);
    }
  };

  useEffect(() => {
    fetchLanguages().then(languages => {
      console.log('Fetched languages:', languages); // Debug line
      setAvailableLanguages(languages);
    });
  }, []);

  // 4. Add the updateUserLanguage function (place after other handler functions)
  const updateUserLanguage = async (langId, langDesc) => {
    try {
      console.log('updateUserLanguage called with:', langId, langDesc);
      const userId = localStorage.getItem('userID');
      console.log('Retrieved userId:', userId);
      
      if (!userId) {
        console.warn('No userId found in localStorage');
        return;
      }

      const response = await fetch('https://xianhefairy.com/LotusFairy_API/api/User/LanguageUpdate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ID: parseInt(userId),
          LANG_ID: langId,
          LANG_DESC: langDesc
        })
      });

      console.log('Response status:', response.status);
      if (!response.ok) {
        console.error('Failed to update user language preference');
      } else {
        console.log('User language preference updated successfully');
      }
    } catch (error) {
      console.error('Error updating user language:', error);
    }
  };

  // Fetch all site content and store by Code
  useEffect(() => {
    const languageId = effectiveLanguageId;
    console.log('Fetching site content with languageId:', languageId); // Debug log
    
    // Fetch content for both codes
    const codes = ['I2E57', '4X9HT', 'EC8V2', 'ECFQE'];
    const fetchPromises = codes.map(code => 
      fetch(`https://xianhefairy.com/LotusFairy_API/api/SiteContent/GetSiteContent?Code=${code}&LangId=${languageId}`)
        .then(res => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.json();
        })
    );

    Promise.all(fetchPromises)
      .then(results => {
        console.log('Site content data received:', results); // Debug log
        
        // Map by Code for easy access
        const contentMap = {};
        results.forEach(data => {
          if (Array.isArray(data)) {
            data.forEach(item => {
              if (item.Code && item.Description && item.Title) {
                contentMap[item.Code] = {
                  Description: item.Description,
                  Title: item.Title
                };
              }
            });
          }
        });
        console.log('Content map created:', contentMap); // Debug log
        setSiteContent(contentMap);
      })
      .catch(err => {
        console.error("Failed to fetch site content:", err);
      });
  }, [effectiveLanguageId]); // Refetch when language changes

  const mainDescription = siteContent["I2E57"]?.Description || "Hello, I'm XianHe Fairy - your Destiny Guide. Tell me your birth date, I can reveal what's rising in your fortune, love, work and wellbeing. Your future's already talking…shall we find out?";
  const chineseDescription = siteContent["4X9HT"]?.Description || "开启你的命运导航";
  const amuSectionTitle = siteContent["EC8V2"]?.Title || "Crafted to stay with you, everyday";
  const amuSectionDescriptionRaw = siteContent["EC8V2"]?.Description || "Each A-MU is thoughtfully designed with symbolic elements to support different aspects of daily life from protection and clarity to emotional balance and personal growth.<br><br>Get your daily A-MU, and explore extended options designed for every stage of your journey.";
  const [amuSectionDescriptionLine1, amuSectionDescriptionLine2] = useMemo(() => {
    const lines = amuSectionDescriptionRaw
      .split(/<br\s*\/?>/i)
      .map((line) => line.trim())
      .filter(Boolean);

    return [lines[0] || "", lines.slice(1).join(" ") || ""];
  }, [amuSectionDescriptionRaw]);

  const rootsSectionTitle = siteContent["ECFQE"]?.Title || "Ancient Roots. Modern You.";
  const rootsSectionDescriptionRaw = siteContent["ECFQE"]?.Description || "Master SiewLi has spent over forty years walking the path of spiritual guidance and XianHe is her bridge between that ancient wisdom and the life you're living today. She built this for modern seekers like you: people who are curious, open, and ready for guidance that actually means something.<br><br>Forty years of spiritual guidance shaped one clear vision: wisdom should be for everyone. Master SiewLi created XianHe to break down the barriers between ancient knowledge and modern life. No gatekeeping. No mystery. Just real guidance for real people, ready to take the next step.";
  const [rootsSectionDescriptionLine1, rootsSectionSubheading, rootsSectionDescriptionLine2] = useMemo(() => {
    const lines = rootsSectionDescriptionRaw
      .split(/<br\s*\/?>/i)
      .map((line) => line.replace(/\u00A0/g, ' ').trim())
      .filter(Boolean);

    if (lines.length >= 3) {
      return [lines[0] || "", lines[1] || "", lines.slice(2).join(" ") || ""];
    }

    // Common API shape: "highlight line<br><br>body line".
    if (lines.length === 2) {
      return ["", lines[0] || "", lines[1] || ""];
    }

    return [lines[0] || "", "", ""];
  }, [rootsSectionDescriptionRaw]);


  // const zodiacDescriptions = {
  //   "Rat": "You’re outgoing, sharp and adaptable. You connect easily with others and learn new skills fast. You notice details, stay focused and bring warmth to everything you do. Your curiosity, drive and positivity help you balance structure with vision.",
  //   "Ox": "You’re thoughtful, diligent and principled. You work steadily toward your goals through focus and determination. Honest and responsible with a caring side, you value loyalty, tradition and doing things the right way from start to finish.",
  //   "Tiger": "You are a brave, ambitious leader who loves taking on challenges and exploring new paths. Honest and reliable and determined, you go after your goals with focus and a positive mindset.",
  //   "Rabbit": "You’re thoughtful, kind and compassionate. With a natural charm that helps you connect with others and turn conflicts into friendships. Family-oriented and graceful, you appreciate beauty and harmony. You are creative, a warm and welcoming person.",
  //   "Dragon": "Like a dragon, you are full of strength and energy. Unstoppable when you go after something you want. Ambitious and driven, you are a talented perfectionist who isn’t afraid to take the lead.",
  //   "Snake": "You are strong, energetic and unstoppable when you set your sights on something. Ambitious and talented, you have a perfectionist streak and are not afraid to step up and take charge.",
  //   "Horse": "You are lively and passionate. With a romantic spirit, with a strong sense of justice and a wide circle of friends. Independent and decisive, you dive into new experiences with confidence, style and determination.",
  //   "Goat": "You’re thoughtful and detail-oriented, valuing sincerity, compassion and kindness which makes you approachable and well-liked. Beneath your graceful, social side is a curious. Hardworking and determined spirit that drives you forward with generosity and focus.",
  //   "Monkey": "You’re a confident, versatile go-getter who thrives on challenges, competition and leadership. Quick to learn and eager to shine, you combine intelligence, charm and boldness to achieve your goals and inspire those around you.",
  //   "Rooster": "You’re intelligent, witty and outspoken. Unafraid to stand out, call out injustice or embrace new trends with confidence. Sociable yet disciplined, you balance charm and competitiveness with a strong sense of responsibility and high standards.",
  //   "Dog": "You’re honest, dependable and principled. Guided by strong morals and a deep sense of justice in everything you do. Compassionate and yet determined, you combine loyalty, intuition and leadership with dedication to the people you care about.",
  //   "Pig": "You’re generous, kind-hearted and loyal. With a strong sense of justice, sincerity that earns lasting friendships. Optimistic and romantic, you stay content, tolerant and unfazed by small conflicts or criticism."
  // };
  // Fetch zodiac descriptions based on language
  useEffect(() => {
    const languageId = effectiveLanguageId;
    
    fetch(`https://xianhefairy.com/LotusFairy_API/api/SiteContent/GetZodiacDetail?LangId=${languageId}`)
      .then(res => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then(data => {
        if (Array.isArray(data)) {
          const descriptionsMap = {};
          data.forEach(item => {
            if (item.Animal) {
              descriptionsMap[item.Animal] = {
                greetings: item.Greetings || '',
                description: item.Description || '',
                symbol: item.Symbol || '',
                zodiac: item.Zodiac || ''
              };
            }
          });
          setZodiacDescriptions(descriptionsMap);
        }
      })
      .catch(err => {
        console.error("Failed to fetch zodiac descriptions:", err);
      });
  }, [effectiveLanguageId]);

  const zodiacMappings = [
    {
      title: "The Dog",
      stem: "DOG",
      image: zodiac1,
    },
    {
      title: "The Dragon",
      stem: "DRAGON",
      image: zodiac2,
    },
    {
      title: "The Goat",
      stem: "GOAT",
      image: zodiac3,
    },
    {
      title: "The Horse",
      stem: "HORSE",
      image: zodiac4,
    },
    {
      title: "The Axe",
      stem: "MONKEY",
      image: zodiac5,
    },
    {
      title: "The Ox",
      stem: "OX",
      image: zodiac6,
    },
    {
      title: "The Pig",
      stem: "PIG",
      image: zodiac7,
    },
    {
      title: "The Rabbit",
      stem: "RABBIT",
      image: zodiac8,
    },
    {
      title: "The Rat",
      stem: "RAT",
      image: zodiac9,
    },
    {
      title: "The Rooster",
      stem: "ROOSTER",
      image: zodiac10,
    },
    {
      title: "The Snake",
      stem: "SNAKE",
      image: zodiac11,
    },
    {
      title: "The Tiger",
      stem: "TIGER",
      image: zodiac12,
    },
  ];


  // Add the same arrays as ElementFinder
  // const months = [
  //   "January",
  //   "February",
  //   "March",
  //   "April",
  //   "May",
  //   "June",
  //   "July",
  //   "August",
  //   "September",
  //   "October",
  //   "November",
  //   "December",
  // ];
  const months = 
    i18n.language === 'id' 
      ? ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
      : i18n.language === 'cn'
      ? ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
      : [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
  const days = Array.from({ length: 31 }, (_, i) => (i + 1).toString());
  const years = Array.from({ length: 2025 - 1935 + 1 }, (_, i) =>
    (1935 + i).toString()
  );

  // Add the same resultMappings as ElementFinder
  const resultMappings = [
    {
      title: "The Mountain",
      stem: "Mountain  ",
      image: image1, // You'll need to import these images
      strength: "Creative, idealistic, and introspective.",
      weakness: "Sometimes detached from reality and overly sensitive.",
      summary: "You have a deep inner world and a vivid imagination.\nYou thrive in environments that allow for self-expression and creativity.",
    },
    {
      title: "The Soil",
      stem: "Soil      ",
      image: image2,
      strength: "As grounded as a lump of soil on the ground.\nAccommodating peacemaker",
      weakness: "Overly cautious and doubtful lives in a cave, unaware of trends",
      summary: "Can The Soil get his head out of the ground?\n- The Star\nHard on the outside, but soft on the inside, am I talking about an egg or The Soil?\n- The Axe",
    },
    {
      title: "The Sun",
      stem: "Sun       ",
      image: image3,
      strength: "You shine as bright as...the Sun. Of course.\nYou are a shining source of fun and adventures",
      weakness: "Your temper is as explosive as the sun is hot.\nMay be confrontational",
      summary: "Wow is he always on fire!\n- The Tree\nHave I told you how hot you are today? Oh? I said it three times already? But The Sun is hot.\n- The Flower",
    },
    {
      title: "The Candle Flame",
      stem: "Candle Flame      ",
      image: image4,
      strength: "You are a superstar, a money star, good with numbers\nConfident and driven",
      weakness: "Competitive risk-taker\nMay be unstable and anxious",
      summary: "Is that a bird, is that a plane, that's a shooting star!\n- The Soil\nStop blinking, twinkling so much so I can see you clearly!\n- The Sun",
    },
    {
      title: "The Axe",
      stem: "Axe       ",
      image: image5,
      strength: "Decisive, chop chop gotta go.\nHonest and analytical",
      weakness: "Unwilling to bury the hatchet.\nHeart and logic as cold as steel.",
      summary: "He chops challenges like he chops my wood!\n- The Tree\nHe always looks like he has an axe to grind.\n- The Mountain",
    },
    {
      title: "The Jewellery",
      image: image6,
      stem: "Jewellery     ",
      strength: "Sharpest knife in the kitchen!\nCuts straight to the point",
      weakness: "Can be very direct.",
      summary: "They say metal reflects light, but really, he deflects my point\n- The Sun",
    },
    {
      title: "The Tree",
      image: image7,
      stem: "Large Tree",
      strength: "You provide shelter to all who come to you.\nYou don't judge.",
      weakness: "You are stubbornly rooted.\nYou can't see the forest for the trees.",
      summary: "The Tree is so tall and inspiring! Yet speaks so gentle and soothing\n- The Flower\nWhy are they so greedy for my sunlight?\n- The Sun",
    },
    {
      title: "The Flower",
      image: image8,
      stem: "Flowers   ",
      strength: "You are caring and helpful\nYou are nurturing and empathetic",
      weakness: "Make up my mind? Make up is meant to go on the face.\nWhen the grass is trampled, the flower flees.",
      summary: "Small, pretty and kinda cute!\n- The Tree\nPretty flower? More like petty flower! Hmph!\n- Another Flower",
    },
    {
      title: "The Ocean",
      stem: "Ocean     ",
      image: image9,
      strength: "Something good about rain clouds here.",
      weakness: "Make up my mind? Make up is meant to go on the face.\nWhen the grass is trampled, the flower flees.",
      summary: "Small, pretty and kinda cute!\n- The Tree\nPretty flower? More like petty flower! Hmph!\n- Another Flower",
    },
    {
      title: "The Rain Water",
      stem: "Rain Water     ",
      image: image10,
      strength: "Something good about rain clouds here.",
      weakness: "Make up my mind? Make up is meant to go on the face.\nWhen the grass is trampled, the flower flees.",
      summary: "Small, pretty and kinda cute!\n- The Tree\nPretty flower? More like petty flower! Hmph!\n- Another Flower",
    },
  ];

  // Modify the date selection handler to use the same API call as ElementFinder
  const handleDateSelection = async () => {
    try {
      const languageId = effectiveLanguageId;
      const custID = localStorage.getItem('userID') || '0';
      
      const url = `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStem`;
      
      const requestBody = {
        cYear: parseInt(selectedYear),
        cMonth: parseInt(selectedMonth),
        cDay: parseInt(selectedDay),
        cTime: "08:30",
        CustID: parseInt(custID),
        LangId: parseInt(languageId)
      };

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data from API");
      }

      const data = await response.json();
      console.log("API response data:", data);
      const stemRelation = data[0]?.STEM_RELATION?.trim();
      const zodiacName = data[0]?.ZODIAC?.trim();
      const zodiacSign = data[0]?.ZODIAC_CN?.trim();

      setZodiacName(zodiacName || "");
      setZodiacSign(zodiacSign || "");

      if (!stemRelation) {
        throw new Error("STEM_RELATION is missing or invalid in the API response");
      }

      const result = resultMappings.find((r) => r.stem.trim() === stemRelation);

      if (result) {
        result.apiStemDescription = data[0]?.STEM_DESCRIPTION || "";
        const zodiacDesc = zodiacDescriptions[zodiacName?.toUpperCase()];
        result.apiZodiacDescription = zodiacDesc ? 
          `${zodiacDesc.greetings}<br><br>${zodiacDesc.description}` : 
          data[0]?.ZODIAC_DESCRIPTION || "";
        setElementFinderResult(result);
        setShowElementResult(true);
      } else {
        console.error("No matching result found for STEM_RELATION:", stemRelation);
      }
    } catch (error) {
      console.error("Error fetching element:", error);
      alert("Error finding your element. Please try again.");
    }
  };

  const handleDateSelection2 = async () => {
    try {
      const languageId = effectiveLanguageId;
      const custID = localStorage.getItem('userID') || '0';
      
      const url = `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStem`;
      
      const requestBody = {
        cYear: parseInt(selectedYear),
        cMonth: parseInt(selectedMonth),
        cDay: parseInt(selectedDay),
        cTime: "08:30",
        CustID: parseInt(custID),
        LangId: parseInt(languageId)
      };

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data from API");
      }

      const data = await response.json();
      console.log("API response data:", data);
      const stemRelation = data[0]?.STEM_RELATION?.trim();
      const zodiacName = data[0]?.ZODIAC?.trim();
      const zodiacSign = data[0]?.ZODIAC_CN?.trim();

      setZodiacName2(zodiacName || "");
      setZodiacSign2(zodiacSign || "");

      if (!stemRelation) {
        throw new Error("STEM_RELATION is missing or invalid in the API response");
      }

      const result = resultMappings.find((r) => r.stem.trim() === stemRelation);

      if (result) {
        result.apiStemDescription = data[0]?.STEM_DESCRIPTION || "";
        const zodiacDesc = zodiacDescriptions[zodiacName?.toUpperCase()];
        result.apiZodiacDescription = zodiacDesc ? 
          `${zodiacDesc.greetings}<br><br>${zodiacDesc.description}` : 
          data[0]?.ZODIAC_DESCRIPTION || "";
        setElementFinderResult_DO_NOT_SHOW(result);
        setShowElementResult(true);
      } else {
        console.error("No matching result found for STEM_RELATION:", stemRelation);
      }
    } catch (error) {
      console.error("Error fetching element:", error);
      alert("Error finding your element. Please try again.");
    }
  };

  // New function to handle "Find Your Destiny" button click
  const handleFindYourDestiny = async () => {
    setShowZodiacTooltip(false); // Reset read more button
    try {
      // First, try to find the element based on selected date
      await handleDateSelection();
      // Then open the ElementFinder modal for the full experience
      //setShowElementFinderModal(true);
    } catch (error) {
      // If element finding fails, still show the modal
      //setShowElementFinderModal(true);
    }
  };

  const handleFindYourDestiny2 = async () => {
    setShowZodiacTooltip2(false); // Reset read more button
    try {
      // First, try to find the element based on selected date
      await handleDateSelection2();
      // Then open the ElementFinder modal for the full experience
      //setShowElementFinderModal(true);
    } catch (error) {
      // If element finding fails, still show the modal
      //setShowElementFinderModal(true);
    }
  };

  const isElementResultOpen = Boolean(elementFinderResult || elementFinderResult_DO_NOT_SHOW);


  // Measure the element region's bounding rect and save it. Called when modal opens
  // and on resize/scroll to keep it in sync.
  const measureElementRegion = useCallback(() => {
    const el = elementRegionRef.current || headingRef.current;
    if (!el || typeof el.getBoundingClientRect !== 'function') return;
    const rect = el.getBoundingClientRect();
    setElementRect({ top: rect.top, left: rect.left, width: rect.width, height: rect.height });
  }, []);

  useEffect(() => {
    if (!showElementFinderModal) return;
    // measure initially
    measureElementRegion();
    // re-measure on scroll/resize
    window.addEventListener('resize', measureElementRegion);
    window.addEventListener('scroll', measureElementRegion, true);
    return () => {
      window.removeEventListener('resize', measureElementRegion);
      window.removeEventListener('scroll', measureElementRegion, true);
    };
  }, [showElementFinderModal, measureElementRegion]);

  // Prevent background scroll when modal is open
  useEffect(() => {
    if (showElementFinderModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [showElementFinderModal]);

  // Hide intro after video ends
  const handleIntroEnd = () => setShowIntro(false);

  useEffect(() => {
    const introVideoElement = introRef.current;
    if (introVideoElement && showIntro) {
      // Reset muted state when component mounts
      setIsIntroMuted(true);

      const handleCanPlay = () => {
        // Autoplay intentionally disabled per request – user will press play manually.
      };

      // Add event listeners
      introVideoElement.addEventListener('canplay', handleCanPlay);

      // Force load the video
      introVideoElement.load();

      return () => {
        introVideoElement.removeEventListener('canplay', handleCanPlay);
      };
    }
  }, [showIntro]);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  //const [currentHighlight, setCurrentHighlight] = useState(0);
  const [currentAmulet, setCurrentAmulet] = useState(0);
  const [isAmuletSliderHovered, setIsAmuletSliderHovered] = useState(false);

  const MOBILE_BREAKPOINT = 852;
  const COMPACT_DESKTOP_MAX_WIDTH = 1500;
  const COMPACT_DESKTOP_MAX_HEIGHT = 900;

  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);
  const [viewportSize, setViewportSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [isCompactDesktop, setIsCompactDesktop] = useState(
    window.innerWidth >= MOBILE_BREAKPOINT &&
      (window.innerWidth <= COMPACT_DESKTOP_MAX_WIDTH || window.innerHeight <= COMPACT_DESKTOP_MAX_HEIGHT)
  );
  useEffect(() => {
    const handleResize = () => {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      setViewportSize({ width: viewportWidth, height: viewportHeight });
      setIsMobile(viewportWidth < MOBILE_BREAKPOINT);
      setIsCompactDesktop(
        viewportWidth >= MOBILE_BREAKPOINT &&
          (viewportWidth <= COMPACT_DESKTOP_MAX_WIDTH || viewportHeight <= COMPACT_DESKTOP_MAX_HEIGHT)
      );
    };

    const measureHeading = () => {
      if (headingRef.current) {
        setHeadingWidth(headingRef.current.offsetWidth);
      }
    };

    // Measure on mount and resize
    measureHeading();
    window.addEventListener('resize', measureHeading);

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener('resize', measureHeading);
    };
  }, [COMPACT_DESKTOP_MAX_HEIGHT, COMPACT_DESKTOP_MAX_WIDTH, MOBILE_BREAKPOINT]);

  const desktopViewportScale = useMemo(() => {
    if (isMobile) return 1;
    const widthScale = viewportSize.width / 2000;
    const heightScale = viewportSize.height / 1100;
    return Math.max(0.56, Math.min(1, Math.min(widthScale, heightScale)));
  }, [isMobile, viewportSize.height, viewportSize.width]);

  const isLargeDesktop = useMemo(
    () => !isMobile && !isCompactDesktop && viewportSize.width >= 1700 && viewportSize.height >= 900,
    [isCompactDesktop, isMobile, viewportSize.height, viewportSize.width]
  );

  const heroContentScale = useMemo(() => {
    if (isMobile) return 1;
    if (isLargeDesktop) {
      return Math.min(1.2, desktopViewportScale * 1.15);
    }
    return desktopViewportScale;
  }, [desktopViewportScale, isLargeDesktop, isMobile]);

  const heroCardsTop = useMemo(() => {
    if (isMobile) return "12%";
    const cardsTopPx = Math.round(Math.max(132, Math.min(viewportSize.height * 0.258, 236)));
    return `${cardsTopPx}px`;
  }, [isMobile, viewportSize.height]);

  const seekHeroCardsVideoToEndFrame = useCallback(() => {
    const video = heroCardsVideoRef.current;
    if (!video) return;

    const duration = Number(video.duration);
    if (!Number.isFinite(duration) || duration <= 0) return;

    const endFrameTime = Math.max(0, duration - 0.04);
    if (Math.abs(video.currentTime - endFrameTime) > 0.015) {
      video.currentTime = endFrameTime;
    }
    video.pause();
  }, []);

  const handleHeroCardsVideoLoadedMetadata = useCallback(() => {
    const video = heroCardsVideoRef.current;

    // On refresh/load always start from frame 0 (not the previous final-frame pose).
    heroCardsHoveredRef.current = false;
    heroCardsPlayedOnceRef.current = false;

    if (video) {
      video.pause();
      try {
        video.currentTime = 0;
      } catch {
        // Ignore seek failures; browser will render from default start frame.
      }
    }

    setIsHeroCardsVideoReady(true);
    setUseHeroCardsGifFallback(false);
  }, []);

  const handleHeroCardsVideoError = useCallback(() => {
    setUseHeroCardsGifFallback(true);
    setIsHeroCardsVideoReady(false);
  }, []);

  const handleHeroCardsVideoEnded = useCallback(() => {
    seekHeroCardsVideoToEndFrame();
    setIsMuted(true);
    const bgVideo = bgVideoRef.current;
    if (bgVideo) {
      bgVideo.muted = true;
      bgVideo.volume = 0;
    }
  }, [seekHeroCardsVideoToEndFrame]);

  const startHeroCardsAnimation = useCallback(() => {
    const video = heroCardsVideoRef.current;
    if (heroCardsPlayedOnceRef.current) return;
    if (isSafariBrowser || useHeroCardsGifFallback || !video || !isHeroCardsVideoReady) return;

    heroCardsPlayedOnceRef.current = true;

    video.pause();
    try {
      video.currentTime = 0;
    } catch {
      // Ignore seek failures; play from current position if browser blocks instant seek.
    }

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {
        setUseHeroCardsGifFallback(true);
        setIsHeroCardsVideoReady(false);
      });
    }

    if (isMuted) {
      setIsMuted(false);
      const bgVideo = bgVideoRef.current;
      if (bgVideo) {
        bgVideo.muted = false;
        bgVideo.volume = 1;
        const bgPlayPromise = bgVideo.play();
        if (bgPlayPromise && typeof bgPlayPromise.catch === "function") {
          bgPlayPromise.catch(() => {});
        }
      }
    }
  }, [isHeroCardsVideoReady, isMuted, isSafariBrowser, useHeroCardsGifFallback]);

  const handleHeroCardsMouseEnter = useCallback(() => {
    if (heroCardsHoveredRef.current) return;
    heroCardsHoveredRef.current = true;
    startHeroCardsAnimation();
  }, [startHeroCardsAnimation]);

  const handleHeroCardsMouseMove = useCallback(() => {
    if (heroCardsHoveredRef.current) return;
    heroCardsHoveredRef.current = true;
    startHeroCardsAnimation();
  }, [startHeroCardsAnimation]);

  const handleHeroCardsMouseLeave = useCallback(() => {
    heroCardsHoveredRef.current = false;
  }, []);

  const handleHeroCardsPointerDown = useCallback(() => {
    heroCardsHoveredRef.current = true;
    startHeroCardsAnimation();
  }, [startHeroCardsAnimation]);

  useEffect(() => {
    const handleWindowBlur = () => {
      heroCardsHoveredRef.current = false;
    };

    window.addEventListener("blur", handleWindowBlur);
    return () => {
      window.removeEventListener("blur", handleWindowBlur);
    };
  }, []);

  const heroHeadingTop = useMemo(() => {
    if (isMobile) return "55%";
    const cardsTopPx = Math.round(Math.max(132, Math.min(viewportSize.height * 0.258, 236)));
    const scaledCenterHeight = Math.round(308 * desktopViewportScale);
    const cardsBottomPx = cardsTopPx + scaledCenterHeight / 2;
    const headingGapPx = isCompactDesktop ? 10 : 28;
    const headingTopPx = Math.round(
      Math.max(240, Math.min(cardsBottomPx + headingGapPx, isCompactDesktop ? 384 : 430))
    );
    return `${headingTopPx}px`;
  }, [desktopViewportScale, isCompactDesktop, isMobile, viewportSize.height]);

  // Push <OurServices /> below the absolutely-positioned hero cards so they don't overlap.
  // Mirrors the math used in heroCardsTop / heroHeadingTop.
  const ourServicesMarginTop = useMemo(() => {
    if (isMobile) {
      // Hero cards sit at top:12% of a ~100vh hero container, centered via translate(-50%,-50%).
      // Push OurServices below the visible bottom of the cards plus a small gap.
      return "48vh";
    }
    const cardsTopPx = Math.round(Math.max(132, Math.min(viewportSize.height * 0.258, 236)));
    const scaledCenterHeight = Math.round(308 * desktopViewportScale);
    const cardsBottomPx = cardsTopPx + scaledCenterHeight / 2;
    const gapPx = isCompactDesktop ? 24 : 40;
    // styles.mainContent has paddingTop ~40px; styles.content starts at that offset,
    // so subtract it when converting the absolute cardsBottomPx to a margin within content.
    const contentPaddingTop = isCompactDesktop ? 28 : 40;
    return `${Math.max(260, cardsBottomPx - contentPaddingTop + gapPx)}px`;
  }, [desktopViewportScale, isCompactDesktop, isMobile, viewportSize.height]);

  const welcomeViewportScale = useMemo(() => {
    if (isMobile) return 1;
    const widthScale = viewportSize.width / 1440;
    const heightScale = viewportSize.height / 860;
    return Math.max(0.78, Math.min(1, Math.min(widthScale, heightScale)));
  }, [isMobile, viewportSize.height, viewportSize.width]);

  const welcomeSectionMetrics = useMemo(() => {
    if (isMobile) {
      return {
        minHeight: "280px",
        marginTop: "-72px",
        paddingTop: "86px",
        paddingBottom: "12px",
      };
    }

    return {
      minHeight: `${Math.max(250, Math.round(340 * welcomeViewportScale))}px`,
      marginTop: `-${Math.max(74, Math.round(120 * welcomeViewportScale))}px`,
      paddingTop: `${Math.max(90, Math.round(132 * welcomeViewportScale))}px`,
      paddingBottom: `${Math.max(16, Math.round(28 * welcomeViewportScale))}px`,
    };
  }, [isMobile, welcomeViewportScale]);

  const selectStyles = {
    backgroundColor: "transparent",
    border: "none",
    color: "#EADDBA",
    padding: isMobile
      ? "0.35rem 1.5rem 0.35rem 0.55rem"
      : heroContentScale >= 1.08
      ? "0.5rem 1.8rem 0.5rem 0.9rem"
      : heroContentScale < 0.9
      ? "0.42rem 1.5rem 0.42rem 0.7rem"
      : "0.45rem 1.65rem 0.45rem 0.8rem",
    borderRadius: 0,
    width: "100%",
    minWidth: 0,
    fontSize: isMobile
      ? "0.9rem"
      : heroContentScale >= 1.08
      ? "1.05rem"
      : desktopViewportScale < 0.76
      ? "0.86rem"
      : desktopViewportScale < 0.9
      ? "0.9rem"
      : "1rem",
    fontWeight: 500,
    outline: "none",
    cursor: "pointer",
    fontFamily: '"DM Sans", sans-serif',
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Cpath d='M3 4.5L6 7.5L9 4.5' stroke='%23EADDBA' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 0.15rem center",
    backgroundSize: "12px 12px",
  };

  const datePickerShellStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: isMobile
      ? "320px"
      : `${Math.max(320, Math.round(450 * heroContentScale))}px`,
    borderRadius: "12px",
    background: "rgba(35, 19, 74, 0.9)",
    border: "1px solid rgba(132, 111, 210, 0.95)",
    boxShadow: "0 10px 26px rgba(0, 0, 0, 0.35)",
    padding: isMobile
      ? "2px 6px"
      : heroContentScale >= 1.08
      ? "3px 11px"
      : desktopViewportScale < 0.9
      ? "2px 8px"
      : "2px 10px",
  };

  const datePickerDividerStyles = {
    width: "1px",
    alignSelf: "stretch",
    background: "rgba(177, 158, 236, 0.6)",
    margin: "6px 2px",
  };

  const datePickerSegmentStyles = {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
  };

  const selectOptionStyles = {
    color: "#1B0E3C",
    backgroundColor: "#FFF8EE",
  };

  const heroSeamOverlayStyles = {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    height: isMobile ? "170px" : isCompactDesktop ? "85px" : "240px",
    pointerEvents: "none",
    zIndex: 1,
    background: `
      linear-gradient(180deg, rgba(23, 19, 38, 0) 0%, rgba(23, 19, 38, 0.18) 26%, rgba(23, 19, 38, 0.58) 60%, rgba(23, 19, 38, 0.9) 82%, #171326 100%),
      radial-gradient(90% 120% at 50% 100%, rgba(110, 78, 172, 0.24) 0%, rgba(23, 19, 38, 0) 58%)
    `,
  };
  const selectStyles2 = {
    backgroundColor: "black",
    border: "2px solid #FFCB21",
    color: "#FFCB21",
    padding: "0.5rem",
    borderRadius: "0.375rem",
    width: isMobile ? "100%" : "auto",
    fontSize: isMobile ? "0.9rem" : "1rem",
  };

  const buttonStyles = {
    backgroundColor: "black",
    border: "2px solid #FFCB21",
    color: "#FFCB21",
    padding: "0.5rem 1rem",
    borderRadius: "0.375rem",
    cursor: "pointer",
    width: isMobile ? "100%" : "auto",
    marginTop: isMobile ? "0.5rem" : "0",
    fontSize: isMobile ? "0.9rem" : "1rem",
  };

  // Typewriter effect using GSAP TextPlugin
  // useEffect(() => {
  //   if (!typeRef.current) return;
  //   // register plugin once
  //   try {
  //     gsap.registerPlugin(TextPlugin);
  //   } catch (e) {
  //     // plugin already registered or registration failed silently
  //   }

  //   // Ensure starting empty
  //   typeRef.current.textContent = "";

  //   const typedText = "Hello, I’m XianHe Fairy - your Destiny Guide. Tell me your birth date, I can reveal what’s rising in your fortune, love, work and wellbeing.  Your future’s already talking…shall we find out?";

  //   const tl = gsap.to(typeRef.current, {
  //     // faster typing: shorter overall duration (length divided by larger number)
  //     duration: Math.max(1, typedText.length / 45), // adaptive but quicker than before
  //     text: typedText,
  //     ease: "none",
  //     delay: 0.8, // slightly earlier start
  //   });

  //   return () => {
  //     try { tl.kill(); } catch (e) { }
  //   };
  // }, []);

  // Example: update your typewriter effect to use mainDescription
  useEffect(() => {
    if (!typeRef.current) return;
    try { gsap.registerPlugin(TextPlugin); } catch (e) {}
    typeRef.current.textContent = "";
    const typedText = mainDescription;
    const tl = gsap.to(typeRef.current, {
      duration: Math.max(1, typedText.length / 45),
      text: typedText,
      ease: "none",
      delay: 0.8,
    });
    return () => { try { tl.kill(); } catch (e) {} };
  }, [mainDescription]);


  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderImages = [highlights1, highlights2, highlights3, highlights4, highlights5, highlights6, highlights7];
  // Dynamic amulet slider items (array of objects: { id, image, name, periodCategory })
  // Start empty; products will populate this from the API. No static image fallbacks.
  const [sliderAmulets, setSliderAmulets] = useState([]);

  // Number of amulets visible at once in the slider (center + radius*2 = total visible)
  const AMULET_VISIBLE_RADIUS = 2; // 2 on each side of current => 5 total
  // Horizontal spacing (in percentage points from center) between adjacent visible amulets
  const AMULET_SPACING = {
    mobile: 45,   // increase to spread items more on mobile (was implicitly 30)
    desktop: 20,  // increase to spread items more on desktop (was 8)
  };

  // Base (unscaled) pixel size for amulet images. The getAmuletStyle scale will be applied on top
  // so increasing this value makes the transitioning/center amulet larger. Adjust as needed.
  // Increased sizes: larger visuals for desktop and mobile
  const AMULET_BASE_SIZE = isMobile ? 260 : isCompactDesktop ? 260 : 300;
  // Make the coin container tall enough to accommodate the scaled amulet (a little padding included)
  const COIN_CONTAINER_HEIGHT = `${Math.round(AMULET_BASE_SIZE * 1.6)}px`;

  // Helper to derive product image URL similar to other components (fallback to existing static images if missing)
  const getProductImageUrl = (product) => {
    if (!product) return "";
    if (product.ImageUrl) return product.ImageUrl;
    if (product.ImageProdId && product.ImageFile) {
      return `/static/media/product/${product.ImageProdId.toString().padStart(5, 0)}/${product.ImageFile}`;
    }
    if (product.FILENAME && product.ID)
      return `/static/media/product/${product.ID.toString().padStart(5, 0)}/${product.FILENAME}.png`;
    return "";
  };

  // Fetch products to populate amulet slider dynamically
  useEffect(() => {
    let isCancelled = false;
    fetch(`https://xianhefairy.com/LotusFairy_API/api/member/getProduct?LangId=${effectiveLanguageId}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((fetchedData) => {
        if (!Array.isArray(fetchedData)) return;
        const allProducts = fetchedData.map((item) => {
          // Determine periodCategory from DESC_ENG (Daily/Monthly/Yearly)
          let periodCategory = "";
          if (item.DESC_ENG && typeof item.DESC_ENG === "string") {
            const firstWord = item.DESC_ENG.split(/\s+/)[0].toLowerCase();
            if (firstWord === "daily" || firstWord === "monthly" || firstWord === "yearly") {
              periodCategory = firstWord;
            } else {
              const lowerDesc = item.DESC_ENG.toLowerCase();
              if (lowerDesc.includes("daily")) periodCategory = "daily";
              else if (lowerDesc.includes("monthly")) periodCategory = "monthly";
              else if (lowerDesc.includes("yearly")) periodCategory = "yearly";
            }
          }

          return {
            raw: item,
            id: item.ID || item.Product_ID || Math.random().toString(36).slice(2),
            name: item.DESC_ENG || item.DISPLAY_NAME || item.FILENAME || "Amulet",
            periodCategory,
            image: getProductImageUrl(item),
            category: item.CATEGORY_DESC || "",
          };
        });

        // Filter logic: explicit Amulet category/name or those with a periodCategory tag
        const amuletCandidates = allProducts.filter(
          (p) =>
            (p.category && p.category.toLowerCase().includes("amulet")) ||
            (p.name && p.name.toLowerCase().includes("amulet")) ||
            p.periodCategory
        );

        if (!amuletCandidates.length) return;

        const enriched = amuletCandidates.map((p) => ({
          ...p,
          image: p.image || "",
        }));

        if (!isCancelled) setSliderAmulets(enriched);
      })
      .catch((err) => {
        console.error("Failed to load amulet products:", err);
      });

    return () => { isCancelled = true; };
  }, [effectiveLanguageId]);

  // Add slider effect
  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
    }, 3000); // Change every 3 seconds

    return () => clearInterval(slideInterval);
  }, sliderImages.length);


  // Add slider styles to your existing styles object
  const sliderStyles = {
    sliderContainer: {
      position: "relative",
      width: "100%",
      // Allow the slider to size to its content; keep a min height so layout doesn't collapse
      height: "auto",
      minHeight: COIN_CONTAINER_HEIGHT,
      overflow: "hidden",
      borderRadius: "10px",
      margin: "0", // Remove margin to maximize space
      // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      // backgroundColor: "lightcoral"
    },
    coinContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: COIN_CONTAINER_HEIGHT,
      position: "relative",
      overflow: "hidden",
      borderRadius: "10px",
      // backgroundColor: "lightblue"
    },
  };

  const getHighlightStyle = (index) => {
    const isActive = currentSlide === index;

    // Invert the relative position calculation for leftward movement
    let relativePosition = index - currentSlide;

    // Handle wrapping: normalize the relative position to be within reasonable bounds
    const totalHighlights = sliderImages.length;
    if (relativePosition > totalHighlights / 2) {
      relativePosition -= totalHighlights;
    } else if (relativePosition < -totalHighlights / 2) {
      relativePosition += totalHighlights;
    }

    const positionSpacing = isMobile ? 45 : 35;
    const position = 50 + (relativePosition * positionSpacing);

    let opacity = isActive ? 1 : 0.6;
    let scale = isActive ? (isMobile ? 1.2 : 1.1) : (isMobile ? 0.8 : 0.7);
    let translateX = 0;

    const maxVisibleDistance = isMobile ? 1 : 4;

    if (Math.abs(relativePosition) > maxVisibleDistance) {
      opacity = 0;
      scale = 0;
    }

    return {
      left: `${position}%`,
      transform: `translate(calc(-50% + ${translateX}px), -50%) scale(${scale})`,
      filter: isActive
        ? "brightness(1.2) saturate(1.2) drop-shadow(0 0 15px rgba(223, 189, 105, 0.8))"
        : "brightness(0.7) saturate(0.5)",
      zIndex: isActive ? 2 : 1,
      opacity: opacity,
      transition: "all 1.2s cubic-bezier(0.4, 0.0, 0.2, 1)",
      visibility: opacity === 0 ? "hidden" : "visible",
      pointerEvents: opacity === 0 ? "none" : "auto",
    };
  };

  useEffect(() => {
    if (!isAmuletSliderHovered || sliderAmulets.length <= 1) return;

    const amuletInterval = setInterval(() => {
      setCurrentAmulet((prev) => (prev + 1) % sliderAmulets.length);
    }, 1500);

    return () => clearInterval(amuletInterval);
  }, [isAmuletSliderHovered, sliderAmulets.length]);

  const getAmuletStyle = (index) => {
    const isActive = currentAmulet === index;

    let relativePosition = index - currentAmulet;

    const totalAmulets = sliderAmulets.length;
    if (relativePosition > totalAmulets / 2) {
      relativePosition -= totalAmulets;
    } else if (relativePosition < -totalAmulets / 2) {
      relativePosition += totalAmulets;
    }

    const positionSpacing = isMobile ? AMULET_SPACING.mobile : AMULET_SPACING.desktop;
    const position = 50 + (relativePosition * positionSpacing);

    // Distance-based appearance (soften contrast for non-center items)
    const distance = Math.abs(relativePosition);
    const maxVisibleDistance = AMULET_VISIBLE_RADIUS; // keeps 5 total

    let opacity;
    let scale;
    if (distance === 0) {
      opacity = 1;
      scale = isMobile ? 1.22 : 1.12;
    } else if (distance === 1) {
      opacity = 0.85; // previously 0.6
      scale = isMobile ? 1.05 : 1.0;
    } else if (distance === 2) {
      opacity = 0.5; // fade farther edge item
      scale = isMobile ? 0.85 : 0.75;
    } else {
      opacity = 0;
      scale = 0;
    }

    const translateX = 0;

    // Softer filter transitions (less harsh desaturation)
    const activeFilter = "brightness(1.15) saturate(1.15) drop-shadow(0 0 12px rgba(223,189,105,0.7))";
    const nearFilter = "brightness(0.95) saturate(0.9)";
    const farFilter = "brightness(0.7) saturate(0.6)";
    let filter;
    if (distance === 0) filter = activeFilter; else if (distance === 1) filter = nearFilter; else if (distance === 2) filter = farFilter; else filter = "brightness(0.5) saturate(0.4)";

    return {
      left: `${position}%`,
      transform: `translate(calc(-50% + ${translateX}px), -50%) scale(${scale})`,
      filter,
      zIndex: distance === 0 ? 3 : distance === 1 ? 2 : 1,
      opacity,
      transition: "all 1s cubic-bezier(0.4, 0.0, 0.2, 1)",
      visibility: opacity === 0 ? "hidden" : "visible",
      pointerEvents: opacity > 0 ? "auto" : "none",
      cursor: distance === 0 ? "default" : opacity > 0 ? "pointer" : "default",
    };
  };

  // Profile dropdown style (matches Tryoutpage pattern)
  const dropdownStyle = useMemo(() => ({
    display: isDropdownVisible ? "block" : "none",
    position: "fixed",
    top: "60px",
    right: isMobile ? "8px" : "150px",
    backgroundColor: "black",
    color: "#DFBD69",
    border: "1px solid #DFBD69",
    minWidth: isMobile ? "200px" : "260px",
    maxWidth: isMobile ? "280px" : "320px",
    boxShadow: "0px 8px 16px 0px rgba(255, 215, 0, 0.25)",
    padding: "10px",
    zIndex: 1200,
    borderRadius: "10px",
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
    transition: "opacity 0.2s ease, transform 0.2s ease",
    opacity: isDropdownVisible ? 1 : 0,
    transform: isDropdownVisible ? "translateY(0)" : "translateY(-4px)",
    pointerEvents: isDropdownVisible ? "auto" : "none",
    willChange: "opacity, transform",
  }), [isDropdownVisible, isMobile]);

  const styles = {
    mainPage: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      width: "100%",
      position: "relative",
      background: "transparent",
      color: "#DFBD69",
      overflow: "visible",
      margin: 0,
      padding: 0,
    },
    hamburgerButton: {
      display: isMobile ? "block" : "none",
      position: "absolute",
      top: "20px",
      left: "20px",
      zIndex: 1001,
      backgroundColor: "transparent",
      border: "none",
      borderRadius: "5px",
      padding: "10px",
      color: "#DFBD69",
      fontSize: "24px",
      cursor: "pointer",
    },
    sidebar: {
      position: "absolute",
      top: isMobile ? "0" : "20px",
      left: isMobile ? "0" : "50%",
      transform: isMobile ? (isMobileMenuOpen ? "translateX(0)" : "translateX(-100%)") : "translateX(-50%)",
      height: isMobile ? "100%" : "auto",
      width: isMobile ? "100%" : "auto",
      backgroundColor: isMobile ? "rgba(0,0,0,0.95)" : "transparent",
      color: "white",
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "center",
      alignItems: "center",
      padding: isMobile ? "10px" : "8px 20px",
      zIndex: 100,
      border: "none",
      gap: isMobile ? "10px" : "24px",
    },
    menuLink: {
      color: "#DFBD69",
      textDecoration: "none",
      padding: isMobile ? "8px 12px" : "8px 12px",
      margin: isMobile ? "6px 0" : "0 12px",
      borderRadius: "5px",
      backgroundColor: "transparent",
      transition: "background-color 0.2s, color 0.2s",
      fontSize: isMobile ? "1rem" : "1rem",
      border: "none",
      textAlign: "center",
      cursor: "pointer",
      width: isMobile ? "100%" : "auto",
    },
    menuLinkHome: {},
    menuLinkActive: { backgroundColor: "#482BE7" },
    mainContent: {
      flex: 1,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      height: isMobile ? "100vh" : "auto",
      minHeight: isMobile ? "100vh" : isCompactDesktop ? "130vh" : "130vh",
      paddingTop: isMobile ? "20px" : isCompactDesktop ? "28px" : "40px",
      paddingBottom: isMobile ? "80px" : isCompactDesktop ? "50px" : "80px",
      position: "relative",
      zIndex: 2,
      overflow: isMobile ? "hidden" : "visible",
      paddingRight: "0",
      backgroundColor: "transparent",
    },
    masterBackground: {
      position: "absolute",
      top: "43%",
      left: isMobile ? "46%" : "35%",
      transform: "translate(-50%, -50%) scale(1.5)",
      width: "100%",
      height: isMobile ? "auto" : "100%",
      objectFit: "scale-down",
      zIndex: -1,
      backgroundColor: "transparent",
    },
    videoBackground: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "fill",
      minWidth: "100%",
      minHeight: "100%",
      zIndex: -1,
      backgroundColor: "black",
    },
    content: {
      zIndex: 1,
      color: "white",
      textAlign: "center",
      marginRight: "0",
      marginTop: isMobile ? "50px" : "0",
      width: isMobile ? "90%" : "100%",
      textShadow: `-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000`,
      lineHeight: "1.2",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      // backgroundColor: "lightcoral"
    },
    title: { fontSize: isMobile ? "2rem" : "2rem", marginBottom: "10px", fontWeight: "bold", border: "none", color: "#DFBD69" },
    lotusFairytitle: { 
      fontSize: isMobile ? "clamp(1.8rem, 8vw, 2.5rem)" : isCompactDesktop ? "clamp(3.2rem, 6.5vw, 4.6rem)" : "6rem", // More responsive sizing
      marginBottom: "10px", 
      fontWeight: "bold", 
      border: "none", 
      color: "#DFBD69" 
    },

    // subtitle: { fontSize: "1.8rem" },
    button: { marginTop: "20px", border: "0px", padding: "30px 40px", backgroundColor: "#482BE7", color: "#DFBD69", textDecoration: "none", fontSize: "16px" },
    muteButton: {
      position: "fixed",
      bottom: isMobile ? "16px" : "20px",
      left: isMobile ? "16px" : "20px",
      width: isMobile ? "44px" : "48px",
      height: isMobile ? "44px" : "48px",
      borderRadius: "50%",
      backgroundColor: "rgba(0,0,0,0.6)",
      color: "white",
      border: "1px solid rgba(223, 189, 105, 0.55)",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1101,
      backdropFilter: "blur(4px)",
      WebkitBackdropFilter: "blur(4px)",
      boxShadow: "0 6px 18px rgba(0,0,0,0.35)",
    },
    muteIcon: { fontSize: "20px" },
    authContainer: { position: "absolute", top: "20px", right: "20px", display: "flex", alignItems: "center", gap: "10px", zIndex: 10 },
    // Make the auth button size driven by padding (auto width) so it remains compact
    // and responsive. Keep a modest minWidth to avoid overly small tap targets on mobile.
    authButton: {
      padding: "clamp(8px, 1.2vw, 14px) clamp(10px, 2.5vw, 20px)",
      borderRadius: "5px",
      border: "none",
      background: "linear-gradient(to right, #DFBD69, #b7954d, #926F34)",
      color: "black",
      cursor: "pointer",
      // Let width be auto so the button fits its content + padding
      width: "auto",
      // Keep reasonable minimum width for touch targets
      minWidth: isMobile ? "120px" : "120px",
      // Slightly reduced height so layout feels less oversized
      height: isMobile ? "36px" : "56px",
      // fontSize will usually be overridden by inline clamp on the button element,
      // but provide a sensible default.
      fontSize: isMobile ? "16px" : "18px",
    },
    userName: { color: "#DFBD69", fontWeight: "bold", letterSpacing: "1px", textShadow: "1px 1px 3px rgba(0,0,0,0.6)" },
    modalOverlay: { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
    modalContent: { background: "radial-gradient(circle,rgba(26, 26, 26, 1) 0%, rgba(9, 9, 9, 1) 50%, rgba(26, 26, 26, 1) 100%)", padding: "20px", marginBottom: "1%", borderRadius: "10px", width: "400px", boxShadow: "0 4px 8px rgba(0,0,0,0.2)" },
    modalHeader: { fontSize: "1.5rem", marginBottom: "15px", textAlign: "center" },
    modalButton: { width: "100%", padding: "10px", marginBottom: "10px", borderRadius: "5px", border: "1px solid #DFBD69", backgroundColor: "#DFBD69", cursor: "pointer", fontSize: "16px", textAlign: "center" },
    modalInput: { width: "100%", padding: "10px", marginBottom: "10px", borderRadius: "5px", border: "1px solid #ccc", fontSize: "16px" },
    modalFooter: { textAlign: "center", marginTop: "10px", marginBottom: "10px" },
    link: { color: "#DFBD69", cursor: "pointer", textDecoration: "none" },
  };

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  };

  const modalStyle2 = {
    backgroundColor: "black",
    padding: "20px",
    borderRadius: "8px",
    minWidth: "300px",
  };

  const inputStyle2 = {
    width: "100%",
    padding: "8px",
    marginBottom: "10px",
  };

  const buttonStyle2 = {
    backgroundColor: "#DFBD69",
    color: "black",
    padding: "10px",
    border: "none",
    borderRadius: "4px",
    width: "100%",
    cursor: "pointer",
  };

  const errorStyle = {
    color: "#dfbd69",
    fontSize: "14px",
    marginBottom: "10px",
  };

  const elementFinderModalStyles = {
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2000,
      padding: isMobile ? "10px" : "20px",
      overflow: "hidden", // Prevent scrolling on overlay
    },
    modalContent: {
      background: "#1f1f1f",
      borderRadius: "16px",
      width: isMobile ? "95vw" : "90vw",
      height: isMobile ? "95vh" : "65vh",
      maxWidth: "1200px",
      maxHeight: "800px",
      position: "relative",
      // Make modal content scrollable on mobile
      overflow: isMobile ? "auto" : "hidden",
      paddingTop: isMobile ? "30px" : "30px", // Reduce top padding for more visible content
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
      display: "flex",
      flexDirection: "column",
    },
    closeButton: {
      position: "absolute",
      top: isMobile ? "20px" : "15px",
      right: "15px",
      background: "#DFBD69",
      color: "#000",
      border: "none",
      borderRadius: "50%",
      width: "40px",
      height: "40px",
      fontSize: "20px",
      cursor: "pointer",
      zIndex: 2001,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "bold",
    },
  };

  // Animation state for Element Finder modal to allow fade in/out
  const [elementFinderModalMounted, setElementFinderModalMounted] = useState(false);
  const [elementFinderModalOpenAnim, setElementFinderModalOpenAnim] = useState(false);

  // Sync mounting and animation when showElementFinderModal changes
  useEffect(() => {
    let timeoutId;
    if (showElementFinderModal) {
      setElementFinderModalMounted(true);
      // allow next tick for CSS transition to pick up
      timeoutId = setTimeout(() => setElementFinderModalOpenAnim(true), 20);
    } else {
      setElementFinderModalOpenAnim(false);
      // wait for animation to finish then unmount
      timeoutId = setTimeout(() => setElementFinderModalMounted(false), 260);
    }
    return () => clearTimeout(timeoutId);
  }, [showElementFinderModal]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleHomeClick = () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn !== "true") {
      alert("You need to login first before accessing this page");
      return;
    } else {
      navigate("/main");
    }
    console.log(isLoggedIn);
  };
  const handleChartClick = () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn !== "true") {
      alert("You need to login first before accessing this page");
      return;
    } else {
      navigate("/chart");
    }
    console.log(isLoggedIn);
  };

  const handleAppointmentClick = () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn !== "true") {
      alert("You need to login first before accessing this page");
      return;
    } else {
      navigate("/myappointment");
    }
    console.log(isLoggedIn);
  };


  useEffect(() => {
    const checkLogin = () => {
      const loggedIn = localStorage.getItem("isLoggedIn") === "true";
      const roleType = localStorage.getItem("roletype");
      const name = localStorage.getItem("name") || "User";
      const shortenedName =
        name.length > 12 ? name.substring(0, 12) + "..." : name;
      setIsLoggedIn(loggedIn);
      
      // Restore language preference after login
      const savedLanguage = localStorage.getItem('language') || 'en';
      setSelectedLanguage(savedLanguage);
      i18n.changeLanguage(savedLanguage);
      
      if (loggedIn) {
        setName(shortenedName);
        if (roleType === "Master") {
          // Redirect to mainmasters page
          window.location.href = "/mainmasters";
        }
      }
    };
    checkLogin();
  }, [i18n]);

  const toggleMute = () => {
    setIsMuted((prev) => {
      const nextMuted = !prev;
      const bgVideo = bgVideoRef.current;
      if (bgVideo) {
        bgVideo.muted = nextMuted;
        bgVideo.volume = nextMuted ? 0 : 1;
        if (!nextMuted) {
          const playPromise = bgVideo.play();
          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(() => {});
          }
        }
      }
      return nextMuted;
    });
  };

  useEffect(() => {
    const bgVideo = bgVideoRef.current;
    if (!bgVideo) return;

    bgVideo.muted = isMuted;
    bgVideo.volume = isMuted ? 0 : 1;

    if (!isMuted) {
      const playPromise = bgVideo.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {});
      }
    }
  }, [isMuted]);

  useEffect(() => {
    const unlockBackgroundAudio = () => {
      if (isMuted) return;
      const bgVideo = bgVideoRef.current;
      if (!bgVideo) return;

      bgVideo.muted = false;
      bgVideo.volume = 1;
      const playPromise = bgVideo.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {});
      }
    };

    window.addEventListener("pointerdown", unlockBackgroundAudio, { passive: true });
    window.addEventListener("keydown", unlockBackgroundAudio);

    return () => {
      window.removeEventListener("pointerdown", unlockBackgroundAudio);
      window.removeEventListener("keydown", unlockBackgroundAudio);
    };
  }, [isMuted]);

  const handleSignIn = () => {
    setShowSignInModal(true);
  };

  const handleModalClose = () => {
    setShowSignInModal(false);
    setShowEmailSignInModal(false);
  };

  const handleEmailSignInOpen = () => {
    setShowSignInModal(false);
    setShowEmailSignInModal(true);
  };

  const handleCollectAmuletClick = () => {
    const loggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (!loggedIn) {
      setShowCollectAmuletLoginModal(true);
      return;
    }
    navigate("/DigitalCharm");
  };

  // TopBar handlers
  const handleDropdownToggle = () => setIsDropdownVisible(prev => !prev);
  const toggleLoginPanel = () => setIsLoginPanelOpen(prev => !prev);

  const handleLogout = () => {
    try {
      localStorage.removeItem("username");
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("coins");
      localStorage.removeItem("comcoins");
    } catch (e) {}
    setIsLoggedIn(false);
    setName("");
    setCoins(0);
    setCartItemCount(0);
    navigate("/main");
    window.location.reload();
  };

  // Cart count effect
  useEffect(() => {
    const fetchCartCount = async () => {
      try {
        const cartRes = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/Usercart/GetUserCart?CustId=${userID}`
        );
        if (!cartRes.ok) return;
        const cartData = await cartRes.json();
        if (Array.isArray(cartData) && cartData.length > 0) {
          const totalItems = cartData.reduce((sum, item) => sum + (item.Qty || 1), 0);
          setCartItemCount(totalItems);
        } else {
          setCartItemCount(0);
        }
      } catch (error) {
        setCartItemCount(0);
      }
    };
    if (userID && isLoggedIn) {
      fetchCartCount();
      const handleCartUpdate = () => fetchCartCount();
      window.addEventListener('cartUpdated', handleCartUpdate);
      const handleStorage = (e) => { if (e.key === "cartUpdatedAt") fetchCartCount(); };
      window.addEventListener('storage', handleStorage);
      const interval = setInterval(fetchCartCount, 3000);
      return () => {
        window.removeEventListener('cartUpdated', handleCartUpdate);
        window.removeEventListener('storage', handleStorage);
        clearInterval(interval);
      };
    } else {
      setCartItemCount(0);
    }
  }, [userID, isLoggedIn, location.pathname]);

  // Coins effect
  useEffect(() => {
    const fetchCoins = async () => {
      try {
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/booking/getTotal?ID=${userID}`,
          { method: "GET", headers: { "Content-Type": "application/json" } }
        );
        if (!response.ok) return;
        const data = await response.json();
        setCoins(data[0].COINS);
      } catch (error) {}
    };
    if (userID && isLoggedIn) {
      fetchCoins();
      const handleGemsUpdate = () => fetchCoins();
      window.addEventListener('gemsUpdated', handleGemsUpdate);
      return () => window.removeEventListener('gemsUpdated', handleGemsUpdate);
    }
  }, [userID, isLoggedIn]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest('[data-myspace-trigger]')) return;
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  const handleGoogleLogin = async () => {
    try {
      // Trigger Google sign-in popup
      const result = await signInWithGooglePopup();

      const name = result.user.displayName;
      const email = result.user.email;
      console.log("User Details:", result);
      console.log("User:", name, email);

      // Check if user account exists by calling the API
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/Booking/getEmailAuth?email=${email}`
      );
      if (!response.ok) {
        throw new Error(`API request failed with status ${response.status}`);
      }

      const apiData = await response.json();
      setPassword(apiData[0].PASSWORD);

      // Check if account exists
      if (apiData.length === 0 || !apiData[0]?.ID) {
        try {
          const response = await fetch(
            "https://xianhefairy.com/LotusFairy_API/api/user/ProfileSaveUpdate?token = xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                ID: "0",
                RefNo: "",
                FName: name,
                LName: "",
                DateOfBirth: "2077-01-01 15:30:45",
                ChineseDateOfBirth: "2077-01-01 15:30:45",
                Gender: "Male",
                Age: "0",
                MobileNo: "0",
                Country: 2143,
                Email: email,
                Password: "098786500",
              }),
            }
          );

          if (!response.ok) {
            throw new Error("Request failed with status " + response.status);
          }
          const result = await response.json();
          if (result) {
            console.log("sucess");
            const url =
              "https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin"; // Your API URL
            const data = {
              UserName: email,
              Password: password,
              Token: {
                AccessToken:
                  "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
              },
            };
            try {
              const response = await fetch(url, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
              });

              const result = await response.json();

              // Assuming your API returns a field 'success' for login status
              if (result && result.ID !== null && result.ID !== undefined) {
                // Do NOT store plaintext passwords in localStorage.
                localStorage.setItem("username", result.username);
                localStorage.setItem("userID", result.ID);
                localStorage.setItem("name", result.FullName);
                localStorage.setItem("isLoggedIn", "true");
                localStorage.setItem("roletype", result.Role);
                localStorage.setItem("email", email);
                await syncProfileLanguageFromGetProfile({ userId: result.ID, userName: email });

                // Navigate based on the username
                if (result.Role === "Master") {
                  navigate("/mainmasters");
                } else if (result.Role === "Member") {
                  navigate("/chart");
                  try {
                    const response = await fetch(
                      `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotal?ID=${result.ID}`
                    );
                    if (!response.ok) {
                      throw new Error("Network response was not ok");
                    }
                    const data = await response.json();
                    localStorage.setItem("coins", data[0].COINS);
                  } catch (error) {
                    console.error("Error fetching coins:", error);
                  }

                  try {
                    const response = await fetch(
                      `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotalCommission?ID=${result.ID}`
                    );
                    if (!response.ok) {
                      throw new Error("Network response was not ok");
                    }
                    const data = await response.json();
                    localStorage.setItem("comcoins", data[0].COINS);
                  } catch (error) {
                    console.error("Error fetching coins:", error);
                  }
                  window.location.reload();
                }
              } else {
                setModalContent({
                  title: "Wrong Credentials",
                  message: "Username or password is incorrect.",
                });
                setIsModal(true);
                console.log(result);
              }
            } catch (error) {
              setModalContent({
                title: "Error",
                message: "An error occurred during login. Please try again.",
              });
              setIsModal(true);
              console.error("Login error:", error);
            }
          }
        } catch (error) {
          console.error("Sign-up error:", error);
        }
      } else {
        console.log("Account found:", apiData[0]);
        const pass = apiData[0]?.PASSWORD;
        const url =
          "https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin"; // Your API URL
        const data = {
          UserName: email,
          Password: pass,
          Token: {
            AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
          },
        };
        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });

          const result = await response.json();
          console.log(data);

          // Assuming your API returns a field 'success' for login status
            if (result && result.ID !== null && result.ID !== undefined) {
            // Do NOT store plaintext passwords in localStorage.
            localStorage.setItem("username", result.username);
            localStorage.setItem("userID", result.ID);
            localStorage.setItem("name", result.FullName);
            localStorage.setItem("isLoggedIn", "true");
            localStorage.setItem("roletype", result.Role);
            localStorage.setItem("email", email);
            await syncProfileLanguageFromGetProfile({ userId: result.ID, userName: email });

            // Navigate based on the username
            if (result.Role === "Master") {
              navigate("/mainmasters");
            } else if (result.Role === "Member") {
              navigate("/chart");
              try {
                const response = await fetch(
                  `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotal?ID=${result.ID}`
                );
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                const data = await response.json();
                localStorage.setItem("coins", data[0].COINS);
              } catch (error) {
                console.error("Error fetching coins:", error);
              }

              try {
                const response = await fetch(
                  `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotalCommission?ID=${result.ID}`
                );
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                const data = await response.json();
                localStorage.setItem("comcoins", data[0].COINS);
              } catch (error) {
                console.error("Error fetching coins:", error);
              }
              window.location.reload();
            }
          } else {
            setModalContent({
              title: "Wrong Credentials",
              message: "Username or password is incorrect.",
            });
            setIsModal(true);
            console.log(result);
          }
        } catch (error) {
          setModalContent({
            title: "Error",
            message: "An error occurred during login. Please try again.",
          });
          setIsModal(true);
          console.error("Login error:", error);
        }
      }
    } catch (error) {
      console.error("Error during Google Sign-In or API call:", error);
    }
  };

  // Add this useEffect to prevent background scrolling when the modal is open
useEffect(() => {
  if (elementFinderResult_DO_NOT_SHOW) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
  return () => {
    document.body.style.overflow = ""; // Cleanup on unmount
  };
}, [elementFinderResult_DO_NOT_SHOW]);

  const handleAppleSignIn = async () => {
    const auth = getAuth();
    const provider = new OAuthProvider("apple.com");

    try {
      const result = await signInWithPopup(auth, provider);

      // Get the signed-in user's info
      const user = result.user;
      const name = result.user.displayName;
      const email = result.user.email;
      console.log("User Info:", user);
      console.log("User:", name, email);

      // Get Apple-specific OAuth token
      const credential = OAuthProvider.credentialFromResult(result);
      const accessToken = credential.accessToken;
      const idToken = credential.idToken;
      console.log("Access Token:", accessToken);
      console.log("ID Token:", idToken);

      try {
        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/Booking/getEmailAuth?email=${email}`
        );
        if (!response.ok) {
          throw new Error(`API request failed with status ${response.status}`);
        }
        const apiData = await response.json();
        setPassword(apiData[0].PASSWORD);
        // Check if account exists
        if (apiData.length === 0 || !apiData[0]?.ID) {
          alert("wont work");
        } else {
          console.log("Account found:", apiData[0]);
          const password = apiData[0]?.PASSWORD;
          const url =
            "https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin"; // Your API URL
          const data = {
            UserName: email,
            Password: password,
            Token: {
              AccessToken:
                "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
            },
          };
          try {
            const response = await fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            });

            const result = await response.json();
            console.log(data);

            // Assuming your API returns a field 'success' for login status
            if (result && result.ID !== null && result.ID !== undefined) {
              // Do NOT store plaintext passwords in localStorage.
              localStorage.setItem("username", result.username);
              localStorage.setItem("userID", result.ID);
              localStorage.setItem("name", result.FullName);
              localStorage.setItem("isLoggedIn", "true");
              localStorage.setItem("roletype", result.Role);
              localStorage.setItem("email", email);
              await syncProfileLanguageFromGetProfile({ userId: result.ID, userName: email });

              // Navigate based on the username
              if (result.Role === "Master") {
                navigate("/mainmasters");
              } else if (result.Role === "Member") {
                navigate("/chart");
                try {
                  const response = await fetch(
                    `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotal?ID=${result.ID}`
                  );
                  if (!response.ok) {
                    throw new Error("Network response was not ok");
                  }
                  const data = await response.json();
                  localStorage.setItem("coins", data[0].COINS);
                } catch (error) {
                  console.error("Error fetching coins:", error);
                }

                try {
                  const response = await fetch(
                    `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotalCommission?ID=${result.ID}`
                  );
                  if (!response.ok) {
                    throw new Error("Network response was not ok");
                  }
                  const data = await response.json();
                  localStorage.setItem("comcoins", data[0].COINS);
                } catch (error) {
                  console.error("Error fetching coins:", error);
                }
                window.location.reload();
              }
            } else {
              setModalContent({
                title: "Wrong Credentials",
                message: "Username or password is incorrect.",
              });
              setIsModal(true);
              console.log(result);
            }
          } catch (error) {
            setModalContent({
              title: "Error",
              message: "An error occurred during login. Please try again.",
            });
            setIsModal(true);
            console.error("Login error:", error);
          }
        }
      } catch (error) {
        console.error("Error during Google Sign-In or API call:", error);
      }
    } catch (error) {
      console.error("Error signing in with Apple:", error);
      if (error.code === "auth/cancelled-popup-request") {
        alert("Sign-in process was cancelled. Try again.");
      }
    }
  };

  // Redirect to HTTPS in production (skip localhost/dev).
  useEffect(() => {
    try {
      if (
        typeof window !== "undefined" &&
        window.location &&
        window.location.protocol === "http:" &&
        !/localhost|127\.0\.0\.1/.test(window.location.hostname)
      ) {
        window.location.replace(window.location.href.replace(/^http:/, "https:"));
      }
    } catch (e) {
      // silent fallback
    }
  }, []);

  const onClick = async () => {
    if (!username || !password) {
      setModalContent({
        title: "Missing Credentials",
        message: "Please enter credentials.",
      });
      setIsModal(true);
      return;
    }

    const url = "https://xianhefairy.com/LotusFairy_API/api/Values/SubmitLogin";
    const data = {
      UserName: username,
      Password: password,
      Token: {
        AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
      },
    };
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (result && result.ID !== null && result.ID !== undefined) {
        // Do NOT store plaintext passwords in localStorage.
        localStorage.setItem("username", username);
        localStorage.setItem("userID", result.ID);
        localStorage.setItem("name", result.FullName);
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("roletype", result.Role);
        await syncProfileLanguageFromGetProfile({ userId: result.ID, userName: username });
        
        // Preserve language preference
        const currentLanguage = localStorage.getItem('language') || 'en';
        localStorage.setItem('language', currentLanguage);

        // Navigate based on the username
        if (result.Role === "Master") {
          navigate("/mainmasters");
        } else if (result.Role === "Member") {
          navigate("/chart");
          try {
            const response = await fetch(
              `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotal?ID=${result.ID}`
            );
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            const data = await response.json();
            localStorage.setItem("coins", data[0].COINS);
          } catch (error) {
            console.error("Error fetching coins:", error);
          }

          try {
            const response = await fetch(
              `https://xianhefairy.com/LotusFairy_API/api/Booking/getTotalCommission?ID=${result.ID}`
            );
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            const data = await response.json();
            localStorage.setItem("comcoins", data[0].COINS);
          } catch (error) {
            console.error("Error fetching coins:", error);
          }
          window.location.reload();
        }
      } else {
        alert("Email or Password is incorrect");
      }
    } catch (error) {
      setModalContent({
        title: "Error",
        message: "An error occurred during login. Please try again.",
      });
      setIsModal(true);
      console.error("Login error:", error);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Open modal if user is logged in
    if (isLoggedIn) {
      setIsModalOpen(true);
    }
  }, [isLoggedIn]); // Runs when isLoggedIn changes

  //Forgot Password
  const [step, setStep] = useState(0); // 1: enter email, 2: verify code, 3: new password
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState();
  const [enteredCode, setEnteredCode] = useState("");
  const [newPass, setNewPass] = useState("");
  const [reNewPass, setReNewPass] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleSendEmail = async () => {
    try {
      const res = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/email/send_reset",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ToEmail: email,
            CreatedBy: email,
          }),
        }
      );
      const result = await res.json();
      if (result) {
        setVerificationCode(result.sentCode); // You might not get the code directly in production
        setErrorMsg("");
        setStep(2);
        console.log(result);
      } else {
        setErrorMsg(result?.Message || "Failed to send reset code.");
        console.log(result);
      }
    } catch (err) {
      console.error(err);
      setErrorMsg("Error sending reset email.");
    }
  };

  const handleVerifyCode = () => {
    if (enteredCode == verificationCode) {
      setErrorMsg("");
      setStep(3);
    } else {
      setErrorMsg("Invalid verification code.");
    }
  };

  const handleChangePassword = async () => {
    console.log("Attempting to update password...");
    // Validate password complexity: min 6 chars, 1 upper, 1 lower, 1 number, 1 special
    const pwdRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\[\]{};':"\\|,.<>\/?`~\-]).{6,}$/;
    if (!pwdRegex.test(newPass)) {
      setErrorMsg(t('signUpPage.passwordRequirements') || 'Password must be at least 6 characters and include uppercase, lowercase, number and special character.');
      return;
    }
    if (newPass !== reNewPass) {
      console.log("Passwords do not match.");
      setErrorMsg(t('loginPage.passwordNotMatch') || "Passwords do not match.");
      return;
    }

    try {
      console.log("Sending password reset request for:", email);
      const res = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/booking/ResetPassword",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Username: email, NewPassword: newPass }),
        }
      );
      const result = await res.json();
      console.log("Password reset response:", result);

      if (res.ok && result?.Success === true) {
        console.log("Password reset successful.");
        setStep(0); // This closes the modal
        setIsModalOpen(false);
        setEmail("");
        setNewPass("");
        setReNewPass("");
        setEnteredCode("");
        setErrorMsg("");
        setSuccessMsg("Password reset successfully.");
        setTimeout(() => {
          window.location.reload();
        }, 2000); // Reload after 2 seconds
      } else {
        console.log("Password reset failed:", result?.Message || "Failed to update password.");
        setErrorMsg(result?.Message || "Failed to update password.");
      }
    } catch (error) {
      console.error("Error updating password:", error);
      setErrorMsg("Error updating password.");
    }
  };

  return (
    <div style={{
      width: "100%",
      height: "auto",
      margin: 0,
      padding: 0,
      position: "relative",
      background: "transparent"
    }}>
      {/* Full-hero background video layer at 15% opacity — covers header + mainContent */}
      <video
        ref={bgVideoRef}
        autoPlay
        loop
        playsInline
        preload="auto"
        defaultMuted
        muted={isMuted}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          width: "100%",
          height: "105vh",
          objectFit: "cover",
          objectPosition: "center",
          opacity: 0.45,
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        <source src={bgvideo} type="video/mp4" />
      </video>
      <button
        type="button"
        onClick={toggleMute}
        style={styles.muteButton}
        title={isMuted ? "Unmute" : "Mute"}
        aria-label={isMuted ? "Unmute background audio" : "Mute background audio"}
      >
        {isMuted ? <FaVolumeMute style={styles.muteIcon} /> : <FaVolumeUp style={styles.muteIcon} />}
      </button>
      {/* Hide native scrollbars visually but keep scrolling behavior */}
      <style>{`
        /* WebKit browsers */
        html, body, #root {
          -webkit-overflow-scrolling: touch;
        }
        ::-webkit-scrollbar { width: 0px; height: 0px; }
        /* Firefox */
        html, body { scrollbar-width: none; }
        /* Edge/IE - use overflow style on elements if needed */
      `}</style>
      {/* typewriter caret removed - no visible cursor requested */}
      {/* Styles for the typed text: gradient, responsive sizing and subtle glow. */}
      <style>{`
        .typed-text {
          /* Use gradient fill for a gold/yellow look */
          background: linear-gradient(90deg, #FFCB21 0%, #FFCB21 50%, #FFCB21 100%);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent; /* show gradient via background-clip */
          display: inline-block;
          line-height: 1.2;
          /* subtle black shadow to improve contrast and legibility */
          text-shadow: 0 1px 0 rgba(255, 217, 0, 0.5), 0 4px 10px rgba(255, 199, 44, 0.4);
          transition: transform 200ms ease, opacity 200ms ease;
          opacity: 1;
          /* Slightly bolder appearance */
          font-weight: 700;
          font-size: 1.2rem;
        }

        /* gentle glow for larger screens */
        @media (min-width: 769px) {
          .typed-text {
            filter: drop-shadow(0 4px 10px rgba(223,189,105,0.12));
          }
        }

        /* responsive font sizes */
        @media (max-width: 768px) {
          .typed-text { font-size: 0.95rem; }
        }
        @media (min-width: 769px) {
          .typed-text { font-size: 1.1rem; }
        }

        /* selection styling (keeps visual consistency when user selects the text) */
        .typed-text::selection {
          background: rgba(255,203,33,0.2);
        }

        /* Glowing styles for the Find Your Destiny button + its text */
        /* Glowing styles for the Find Your Destiny button + its text */
        .find-destiny-btn {
          position: relative; /* allow halo ::after */
          overflow: visible;
          transition: box-shadow 240ms ease, transform 200ms ease, color 160ms ease, background-color 160ms ease;
          box-shadow: 0 0 0px rgba(255,203,33,0);
          will-change: box-shadow, transform;
        }

        /* soft halo element behind the button for a stronger glowing presence */
        .find-destiny-btn::after {
          content: "";
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%) scale(0.85);
          width: 120%;
          height: 120%;
          border-radius: 999px;
          background: radial-gradient(circle at center, rgba(255,203,33,0.30) 0%, rgba(255,203,33,0.12) 30%, rgba(255,203,33,0.04) 60%, transparent 100%);
          filter: blur(10px);
          opacity: 0;
          pointer-events: none;
          transition: opacity 280ms ease, transform 600ms ease;
          z-index: -1;
        }

        /* Keep hover visuals always-on when .glow-on is present */
        .find-destiny-btn.glow-on {
          animation: glowPulse 1.6s ease-in-out infinite;
          transform: translateY(-2px);
          box-shadow: 0 12px 40px rgba(255,203,33,0.25), 0 0 60px rgba(255,203,33,0.18) inset;
        }

        .find-destiny-btn.glow-on::after {
          opacity: 1;
          transform: translate(-50%, -50%) scale(1);
          animation: haloPulse 1.6s ease-in-out infinite;
        }

        /* Apply a stronger glowing text effect to the button label when given the class */
        .glow-text {
          text-shadow: 0 0 10px rgba(255,203,33,0.95), 0 0 30px rgba(255,180,24,0.6), 0 6px 30px rgba(0,0,0,0.6);
          -webkit-text-stroke: 0.3px rgba(255, 230, 150, 0.75);
          transition: text-shadow 240ms ease;
        }

        @keyframes glowPulse {
          0% {
            box-shadow: 0 8px 22px rgba(255,203,33,0.14), 0 0 12px rgba(255,203,33,0.06);
            transform: translateY(0) scale(1);
          }
          50% {
            box-shadow: 0 18px 60px rgba(255,203,33,0.28), 0 0 80px rgba(255,203,33,0.18);
            transform: translateY(-2px) scale(1.02);
          }
          100% {
            box-shadow: 0 8px 22px rgba(255,203,33,0.14), 0 0 12px rgba(255,203,33,0.06);
            transform: translateY(0) scale(1);
          }
        }

        @keyframes haloPulse {
          0% { transform: translate(-50%, -50%) scale(0.97); opacity: 0.75; }
          50% { transform: translate(-50%, -50%) scale(1.06); opacity: 1; }
          100% { transform: translate(-50%, -50%) scale(0.97); opacity: 0.75; }
        }

        /* Stronger hover glow on non-touch devices */
        @media (hover: hover) and (pointer: fine) {
          /* Strengthen text glow whenever button has persistent glow */
          .find-destiny-btn.glow-on.glow-text {
            text-shadow: 0 0 10px rgba(255,203,33,1), 0 0 28px rgba(255,180,24,0.85), 0 6px 26px rgba(0,0,0,0.6);
          }
        }

        .gradient-text {
          background: linear-gradient(0deg, #6E5B1D 0%, #A2862A 100%);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          font-weight: bold;
        }
        @media (min-width: 769px) and (max-width: 1500px), (min-width: 769px) and (max-height: 900px) {
          .mainContent {
            overflow-x: hidden !important;
            overflow-y: auto !important;
          }

          .logoContainer {
            margin-bottom: -75px !important;
          }

          .main-logo-img {
            max-width: 60% !important;
            max-height: 50% !important;
            top: 115px !important; /* Adjust logo position */
            left: 215px !important;
          }

          .jomhuria-heading {
            height: 80px !important; /* Reduced height */
            font-size: 3rem !important; /* Optional: reduce font size for heading */
          }
          
          .heading { max-width: min(90vw, 820px) !important; }
          
          .lotusFairytitle {
            font-size: clamp(1.6rem, 7vw, 2.3rem) !important;
            line-height: 1.1 !important;
          }
          
          .typed-text {
            font-size: clamp(0.8rem, 3.2vw, 1rem) !important;
            line-height: 1.3 !important;
            padding: 0 5px !important;
          }
          
          .subHeading {
            margin-bottom: 1.2rem !important;
          }
          
          /* Keep the hero picker compact on medium screens */
          .hero-date-select {
            font-size: 0.85rem !important;
            padding: 0.4rem !important;
          }
          
          .find-destiny-btn.glow-on {
            font-size: 0.9rem !important;
            padding: 10px 20px !important;
          }

          .welcome-background-text {
            font-size: 27rem !important;
            top: 6% !important;
          }
        }
        @media (max-width: 768px) {
          .mainContent {
            overflow-x: hidden !important;
            overflow-y: auto !important;
          }
          
          .heading {
            transform: translate(-50%, -50%) scale(0.88) !important;
            max-width: 94vw !important;
          }
          
          .lotusFairytitle {
            font-size: clamp(1.6rem, 7vw, 2.3rem) !important;
            line-height: 1.1 !important;
          }
          
          .typed-text {
            font-size: clamp(0.8rem, 3.2vw, 1rem) !important;
            line-height: 1.3 !important;
            padding: 0 5px !important;
          }
          
          .subHeading {
            margin-bottom: 1.2rem !important;
          }
          
          /* Keep the hero picker compact on small screens */
          .hero-date-select {
            font-size: 0.85rem !important;
            padding: 0.4rem !important;
          }
          
          .find-destiny-btn.glow-on {
            font-size: 0.9rem !important;
            padding: 10px 20px !important;
          }

          .welcome-background-text {
            font-size: 15rem !important;
            top: 3% !important;
          }
        }
        
        /* Extra small screens */
        @media (max-width: 480px) {
          .heading {
            top: 62% !important;
            transform: translate(-50%, -50%) scale(1) !important;
          }

          .welcome-section {
            max-width: 100vw !important;
          }

          .welcome-background-text {
            font-size: 9rem !important;
            top: 2% !important;
            max-width: 100vw !important;
            opacity: 0.3 !important;
          }
        }

        .nav-link {
          text-decoration: none;
          color: #DFBD69;
          font-weight: 600;
          font-size: 14px;
          background: transparent;
          border: none;
          cursor: pointer;
          transition: color .25s;
          width: 100%;
        }

        .nav-link:hover {
          color: #FFFFFF;
          text-shadow: 0 0 4px rgba(255,255,255,0.35);
        }
      `}</style>
      {/* Force gradient text for the main Jomhuria heading (fallbacks and vendor prefixes included) */}
      <style>{`
        /* Remove CSS gradient background from the container to avoid a visible rectangle behind the SVG.
           The SVG provides its own gradient fill on the text, so keep a simple fallback color here. */
        .jomhuria-heading {
          color: #DFBD69;
          display: inline-block;
        }
        /* Fallback for browsers that don't support SVG gradient fills (rare) */
        @supports not ((-webkit-background-clip: text) or (background-clip: text)) {
          .jomhuria-heading { color: #DFBD69 !important; -webkit-text-fill-color: initial; }
        }
      `}</style>
      <style>{`
        /* Remove default white background on focus for buttons/links in sidebar */
        .sidebar-button, .sidebar-link {
          background: transparent !important;
          color: #DFBD69 !important;
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
        }
        .sidebar-button:focus, .sidebar-button:active,
        .sidebar-link:focus, .sidebar-link:active {
          background: transparent !important;
          color: #DFBD69 !important;
          outline: none !important;
          box-shadow: none !important;
        }
        /* Keep a visible active state without white background */
        .sidebar-button.active, .sidebar-link.active {
          // background-color: #482BE7 !important;
          color: #DFBD69 !important;
        }
      `}</style>
      <style>
      {`
        .element-modal-content b {
          color: #FFF6D7 !important;
          font-weight: 700 !important;
          font-size: 1.08em;
          letter-spacing: 0.02em;
          text-shadow: 0 1px 8px #FFF6D7, 0 0 2px #000;
          background: none;
          padding: 0 2px;
          border-radius: 2px;
          /* Optionally add a subtle glow */
          // filter: drop-shadow(0 0 6px #FFF6D7);
        }
      `}
      </style>

      <div style={{ ...styles.mainPage }}>

        {/* Header with TopBar */}
        <header style={{ height: 'auto', paddingRight: 0, position: 'relative', zIndex: 1100 }}>
          <TopBar
            cartCount={cartItemCount}
            isLoggedIn={isLoggedIn}
            onCartClick={() => navigate('/cart')}
            onMySpaceClick={handleDropdownToggle}
            onSignInClick={toggleLoginPanel}
          />
        </header>

        {/* Profile dropdown — position:fixed, renders above all content */}
        {isLoggedIn && (
          <div ref={dropdownRef}>
            <div style={dropdownStyle} role="menu" aria-hidden={!isDropdownVisible}>
              <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '10px', marginLeft: '5px' }}>
                <div style={{ backgroundColor: "black", border: "1px solid #ddd", borderRadius: "5px", padding: "8px 12px", margin: "0 5px", textAlign: "center", fontSize: "16px", fontWeight: "bold", flex: "1", justifyContent: "center", alignContent: "center", flexDirection: "row", height: "50px" }}>
                  <img src={coinsImg} alt="Gems" style={{ height: "50%" }} />{" "}
                  {coins} {t('tryoutpage.gems')}
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '10px', marginTop: '15px', alignItems: 'stretch', justifyContent: 'space-between', flexWrap: 'nowrap', overflowX: 'auto' }}>
                <button style={{ backgroundColor: "black", border: "1px solid #dcdcdc", padding: "5px 12px", borderRadius: "5px", cursor: "pointer", color: "#DFBD69", fontSize: "14px", flex: 1, whiteSpace: "nowrap", textAlign: "center" }} onClick={() => navigate('/account')}>
                  {t('tryoutpage.account')}
                </button>
                <Link to="/purchasehistory" style={{ backgroundColor: "black", border: "1px solid #dcdcdc", padding: "5px 12px", borderRadius: "5px", cursor: "pointer", color: "#DFBD69", fontSize: "14px", textDecoration: "none", flex: 1, whiteSpace: "nowrap", textAlign: "center" }}>
                  {t('tryoutpage.history')}
                </Link>
                <button style={{ backgroundColor: "black", border: "1px solid #dcdcdc", padding: "5px 12px", borderRadius: "5px", cursor: "pointer", color: "#DFBD69", fontSize: "14px", flex: 1, whiteSpace: "nowrap", textAlign: "center" }} onClick={handleLogout}>
                  {t('tryoutpage.logout')}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Login panel — slides in from the right */}
        {isLoginPanelOpen && (
          <>
            <div style={{ position: "fixed", top: 0, right: 0, width: isMobile ? "100vw" : "30vw", height: "100%", backgroundColor: "black", boxShadow: "0 0 10px rgba(0,0,0,0.5)", transform: "translateX(0)", transition: "transform 0.3s ease-in-out", zIndex: 10000 }}>
              <Login onClose={toggleLoginPanel} />
            </div>
            <div onClick={toggleLoginPanel} style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: isMobile ? "black" : "rgba(0,0,0,0.5)", zIndex: 9999 }} />
          </>
        )}

        {showCollectAmuletLoginModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.65)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 12000,
              padding: "20px",
              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                width: "100%",
                maxWidth: "460px",
                background: "radial-gradient(circle, rgba(28, 18, 52, 0.96) 0%, rgba(9, 9, 18, 0.96) 100%)",
                border: "1px solid rgba(223, 189, 105, 0.85)",
                borderRadius: "14px",
                padding: isMobile ? "20px" : "26px",
                boxShadow: "0 20px 50px rgba(0, 0, 0, 0.45)",
                color: "#F8F5FE",
                textAlign: "center",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  marginBottom: "10px",
                  color: "#DFBD69",
                  fontFamily: '"PlayfairDisplay", serif',
                  fontSize: isMobile ? "1.3rem" : "1.5rem",
                }}
              >
                {t("mainPage.loginRequiredForAmulet", "Login Required")}
              </h3>
              <p
                style={{
                  margin: 0,
                  marginBottom: "22px",
                  lineHeight: 1.6,
                  fontSize: isMobile ? "0.95rem" : "1rem",
                  color: "rgba(248, 245, 254, 0.92)",
                }}
              >
                {t(
                  "mainPage.loginSignupBeforeCollecting",
                  "You need to login or sign up first before collecting your amulet."
                )}
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  gap: "10px",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={() => {
                    setShowCollectAmuletLoginModal(false);
                    if (!isLoginPanelOpen) {
                      setIsLoginPanelOpen(true);
                    }
                  }}
                  style={{
                    minHeight: "44px",
                    padding: "10px 20px",
                    borderRadius: "10px",
                    border: "none",
                    background: "linear-gradient(to right, #DFBD69, #B9954D)",
                    color: "#150A2A",
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                >
                  {t("mainPage.login", "Login")}
                </button>
                <button
                  onClick={() => {
                    setShowCollectAmuletLoginModal(false);
                    navigate("/signup");
                  }}
                  style={{
                    minHeight: "44px",
                    padding: "10px 20px",
                    borderRadius: "10px",
                    border: "1px solid rgba(223, 189, 105, 0.85)",
                    background: "transparent",
                    color: "#DFBD69",
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                >
                  {t("mainPage.signup", "Sign Up")}
                </button>
                <button
                  onClick={() => setShowCollectAmuletLoginModal(false)}
                  style={{
                    minHeight: "44px",
                    padding: "10px 20px",
                    borderRadius: "10px",
                    border: "1px solid rgba(248, 245, 254, 0.25)",
                    background: "transparent",
                    color: "#F8F5FE",
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  {t("mainPage.close", "Close")}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Main content */}
        <div style={styles.mainContent}>
          {/* Background stars covering the whole mainContent */}
          {/* <img
            src={backgroundStars}
            alt="Background Stars"
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              // objectFit: "cover",
              objectFit: "cover",
              zIndex: -10,
              pointerEvents: "none",
              opacity: 0.7,
            }}
          /> */}

          {/* animated fairy (background) - keep the element anchored at top:0 but shift
              the video's internal framing using objectPosition so the visible content
              appears lower without moving the element itself (prevents parent clipping). */}
          {/* Mobile-specific CSS below ensures the video centers in the viewport and
              is not clipped on small screens. We give the element a class so the
              media rule applies regardless of the `isMobile` JS flag. */}
          <style>{`
            @media (max-width: 768px) {
              /* On mobile show the full video without cropping: use contain so
                 the entire frame is visible (letterboxed if aspect differs).
                 Center the video in the viewport. */
              .animated-fairy-video {
                position: absolute !important;
                top: 0 !important;
                left: 0 !important;
                width: 100vw !important;
                height: 100vh !important;
                /* Keep entire frame visible where possible */
                object-fit: contain !important;
                /* Slight left bias so when we nudge the visual it feels left-shifted */
                object-position: 40% 50% !important;
                /* Apply a modest zoom and left shift; small enough to avoid heavy cropping
                   while still giving a zoomed-in visual. Increase scale slightly if you
                   want stronger zoom (may crop more). */
                transform: translateX(-34%) translateY(-5%) scale(1.7) !important;
                transform-origin: center center !important;
                z-index: -1000 !important;
                pointer-events: none !important;
                background: transparent !important;
              }
            }
          `}</style>

          <>
            {/* {showPlayOverlay && (
              <button
                style={{
                  position: "absolute",
                  bottom: "1%",
                  right: "1%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 10000,
                  padding: "5px 20px",
                  fontSize: "1.5rem",
                  background: "#FFCB21",
                  color: "#000",
                  borderRadius: "30px",
                  border: "none",
                  cursor: "pointer",
                  opacity: 0.8,
                }}
                onClick={handlePlayClick}
              >
                ▶
              </button>
            )} */}
            <video
              ref={videoRef}
              src={animatedFairy}
              loop
              playsInline
              autoPlay
              muted
              style={{
                position: isMobile ? "absolute" : "absolute",
                top: isMobile ? 0 : 0,
                left: isMobile ? 0 : "52%",
                width: isMobile ? "100vw" : "100%",
                height: isMobile ? "100vh" : "100%",
                objectFit: isMobile ? "contain" : "cover", 
                /* Center the visible area on mobile so the whole video is shown */
                objectPosition: isMobile ? "50% 50%" : "50% 30%",
                /* Remove mobile zoom/shift so the video isn't cropped; keep desktop transform  */
                transform: isMobile ? "none" : "translateX(-50%) scale(0.78)",
                opacity: 1,
                transition: "opacity 240ms ease, transform 240ms ease",
                zIndex: -1000,
                pointerEvents: "none",
                opacity: 0,
              }}
            />
          </>

          {/* Hero Cards - animated asset */}
          <div
            ref={heroCardsContainerRef}
            onMouseEnter={handleHeroCardsMouseEnter}
            onMouseMove={handleHeroCardsMouseMove}
            onMouseLeave={handleHeroCardsMouseLeave}
            onPointerEnter={handleHeroCardsMouseEnter}
            onPointerMove={handleHeroCardsMouseMove}
            onPointerLeave={handleHeroCardsMouseLeave}
            onPointerDown={handleHeroCardsPointerDown}
            style={{
              position: "absolute",
              top: heroCardsTop,
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: isMobile ? "88vw" : `${Math.max(640, Math.round(860 * desktopViewportScale))}px`,
              maxWidth: isMobile ? "660px" : "900px",
              zIndex: isElementResultOpen ? 0 : 5,
              pointerEvents: "auto",
            }}
          >
            <img
              src={animatedCardsGif}
              alt="animated cards"
              style={{
                display: "block",
                width: "100%",
                height: "auto",
                filter: "drop-shadow(0 10px 28px rgba(0,0,0,0.5))",
                visibility: useHeroCardsGifFallback || !isHeroCardsVideoReady ? "visible" : "hidden",
              }}
            />

            {!isSafariBrowser && !useHeroCardsGifFallback && (
              <video
                ref={heroCardsVideoRef}
                src={animatedCardsWebm}
                muted
                playsInline
                preload="metadata"
                onLoadedMetadata={handleHeroCardsVideoLoadedMetadata}
                onEnded={handleHeroCardsVideoEnded}
                onError={handleHeroCardsVideoError}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  display: "block",
                  width: "100%",
                  height: "auto",
                  filter: "drop-shadow(0 10px 28px rgba(0,0,0,0.5))",
                  visibility: isHeroCardsVideoReady ? "visible" : "hidden",
                  pointerEvents: "none",
                }}
              />
            )}
          </div>

          {/* Small top-left logo */}
          <div style={styles.content}>
            {/* Left-side heading and subtitle */}
            <div
              className="heading"
              ref={(el) => {
                elementRegionRef.current = el;
                headingRef.current = el;
              }}
              style={{
                position: "absolute",
                left: "50%",
                top: heroHeadingTop,
                transform: isMobile
                  ? "translate(-50%, -50%) scale(0.85)"
                  : "translate(-50%, 0)",
                textAlign: "center",
                zIndex: 1002,
                maxWidth: isMobile
                  ? "94vw"
                  : `${Math.max(560, Math.round(920 * heroContentScale))}px`,
                width: "100%",
                boxSizing: "border-box",
                padding: isMobile
                  ? "0 10px"
                  : desktopViewportScale < 0.9
                  ? "0 16px"
                  : "0 20px",
              }}
            >
              </div>
            <div style={{ width: "100%", marginTop: ourServicesMarginTop }}>
              <OurServices />
            </div>

          </div>

          <div aria-hidden="true" style={heroSeamOverlayStyles} />

        </div>


        {/* Element Finder Modal */}
        {/* {elementFinderModalMounted && (
          // Animated overlay and content. On desktop, position over measured heading region when available.
          <div
            style={{
              ...(!isMobile && elementRect
                ? {
                  position: 'absolute',
                  top: elementRect.top + window.scrollY,
                  left: elementRect.left + window.scrollX,
                  width: elementRect.width,
                  height: elementRect.height,
                  borderRadius: 12,
                  zIndex: 2000,
                }
                : { position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 2000 }
              ),
              // Overlay visual
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: elementFinderModalOpenAnim ? 'rgba(0,0,0,0.8)' : 'rgba(0,0,0,0.0)',
              transition: 'background-color 240ms ease, opacity 240ms ease',
              opacity: elementFinderModalOpenAnim ? 1 : 0,
              pointerEvents: elementFinderModalOpenAnim ? 'auto' : 'none',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                ...elementFinderModalStyles.modalContent,
                // entry animation: scale & translateY slightly + opacity
                transform: elementFinderModalOpenAnim ? 'translateY(0) scale(1)' : 'translateY(8px) scale(0.985)',
                opacity: elementFinderModalOpenAnim ? 1 : 0,
                transition: 'transform 240ms cubic-bezier(0.2,0,0,1), opacity 300ms ease',
              }}
            >
              <button
                style={elementFinderModalStyles.closeButton}
                onClick={() => setShowElementFinderModal(false)}
                title="Close"
              >
                ×
              </button>
              <div style={{
                width: "100%",
                height: "100%",
                overflow: "visible", // Allow content to be fully visible
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
              }}>
                <div style={{ marginTop: isMobile ? 30 : 20, width: "100%" }}>
                  <ElementFinder />
                </div>
              </div>
            </div>
          </div>
        )} */}


        {/* <div
            style={{
              ...styles.authContainer,
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {isLoggedIn ? (
              <>
                <div style={styles.userName}>{name}</div> */}
        {/* <XianheModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} style={{height:'300px'}} /> */}
        {/* </>
            ) : (
              <>
                <button style={styles.authButton} onClick={handleSignIn}>
                  Log In
                </button>
              </>
            )}
            <div
              style={{ marginTop: "10px", fontSize: "20px", color: "#DFBD69" }}
            >
              仙
            </div>
            <div style={{ fontSize: "20px", color: "#DFBD69" }}>荷</div>
          </div> */}

      </div>



      {/* HIGHLIGHTS SECTION */}

      {/* <div style={{ 
        height: isMobile ? "30vh" : "70vh",
        background: `
          linear-gradient(to top, rgba(9,9,9,1) 0%, rgba(9,9,9,0.6) 40%, rgba(0,0,0,0) 100%),
          radial-gradient(circle, rgba(0, 0, 0, 1) 0%, rgba(9, 9, 9, 1) 50%, rgba(26, 26, 26, 1) 100%)
        `,
        transition: "all 0.8s cubic-bezier(0.25,0.46,0.45,0.94)",
        opacity: 1,
        transform: "translateX(0)",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: "20px",
        position: "relative",
        width: "100vw",
        zIndex: 1,
      }}>
 
        <h2
          className="jomhuria-heading"
          style={{
            // copied visual style from the main jomhuria heading to match font/appearance
            ...styles.lotusFairytitle,
            fontSize: isMobile ? "2.5rem" : "4rem",
            lineHeight: 1,
            letterSpacing: isMobile ? "0.04em" : "0.08em",
            // Use the same solid gold color as the jomhuria heading
            color: "#FFCB21",
            WebkitTextFillColor: "initial",
            display: "inline-block",
            WebkitBoxDecorationBreak: "clone",
            overflow: "visible",
            backgroundRepeat: "no-repeat",
            marginBottom: "10px",
            marginTop: "0",
            fontWeight: "bold",
            textAlign: "left",
            // alignSelf: "flex-start",
            paddingLeft: "30px",
            width: "100%",
            // backgroundColor: "green",
            textAlign: "center"
          }}
        >
          Highlights
        </h2>
        

        <div className="highlightsSlider" 
        style={sliderStyles.sliderContainer}>
          <div style={sliderStyles.coinContainer}>
            {sliderImages.map((image, index) => {
              // Use a larger base for highlights (scale from amulet base)
              const highlightBase = Math.round(AMULET_BASE_SIZE * (isMobile ? 1.4 : 2.2));
              return (
                <img
                  key={index}
                  src={image}
                  alt={`Coin ${index + 1}`}
                  style={{
                    width: `${highlightBase}px`,
                    height: `${highlightBase}px`,
                    objectFit: "contain",
                    transition: "all 1.2s cubic-bezier(0.4, 0.0, 0.2, 1)",
                    borderRadius: "10px",
                    position: "absolute",
                    top: "50%",
                    ...getHighlightStyle(index),
                  }}
                />
              );
            })}
          </div>  
        </div>
      </div> */}

      {/* AMULETS SECTION */}

      {/* <div style={{ 
        height: "30vh",
        background: "radial-gradient(circle,rgba(0, 0, 0, 1) 0%, rgba(9, 9, 9, 1) 50%, rgba(26, 26, 26, 1) 100%)",
        transition: "all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
        opacity: 1,
        transform: "translateX(0)",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        padding: "20px", // Add padding for spacing
        position: "relative",
        width: "100vw",
        
      }}>

        <h2 style={{
          color: "#DFBD69",
          fontSize: isMobile ? "1.5rem" : "2rem",
          marginBottom: "10px",
          marginTop: "0",
          fontWeight: "bold",
          textAlign: "left",
          textShadow: `
            -1px -1px 0 #000, 
            1px -1px 0 #000, 
            -1px 1px 0 #000, 
            1px 1px 0 #000
          `,
          alignSelf: "flex-start",
          paddingLeft: "30px", // Use paddingLeft instead of marginLeft
          width: "100%", // Ensure it takes full width
        }}>
          Amulets
        </h2>


        <div style={sliderStyles.sliderContainer}>
          <div style={sliderStyles.coinContainer}>
            {sliderAmulets.map((amulet, index) => {
              const imgSrc = typeof amulet === 'string' ? amulet : amulet.image;
              const label = typeof amulet === 'string' ? `Amulet ${index + 1}` : amulet.name || `Amulet ${index + 1}`;
              return (
                <img
                  key={amulet.id || index}
                  src={imgSrc}
                  alt={label}
                  style={{
                    width: isMobile ? "100px" : "120px",
                    height: isMobile ? "100px" : "120px",
                    objectFit: "contain",
                    transition: "all 1.2s cubic-bezier(0.4, 0.0, 0.2, 1)",
                    borderRadius: "10px",
                    position: "absolute",
                    top: "50%",
                    // Corrected function name & limited visibility handled inside style helper
                    ...getAmuletStyle(index),
                  }}
                />
              );
            })}
          </div>  
        </div>
      </div> */}



      {/* Intro Video Section */}
      {/* {showIntro && (
        <div
          style={{
            width: "100vw",
            minHeight: "60vh",
            background: "radial-gradient(circle,rgba(0, 0, 0, 1) 0%, rgba(9, 9, 9, 1) 50%, rgba(26, 26, 26, 1) 100%)",
            display: "flex",
            flexDirection: "column", // Changed to column layout
            alignItems: "flex-start", // Align to left like other sections
            justifyContent: "flex-start", // Start from top
            position: "relative",
            zIndex: 2,
            padding: "20px", // Add padding like other sections
          }}
        >
          
          <h2 style={{
            color: "#DFBD69",
            fontSize: isMobile ? "1.5rem" : "2rem",
            marginBottom: "20px", // Add more space below header
            marginTop: "0",
            fontWeight: "bold",
            textAlign: "left",
            textShadow: `
              -1px -1px 0 #000, 
              1px -1px 0 #000, 
              -1px 1px 0 #000, 
              1px 1px 0 #000
            `,
            paddingLeft: "30px",
            width: "100%",
          }}>
            Introductory Video
          </h2>
          
          
          <div style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
          }}>
            <video
              ref={introRef}
              src={introVideo}
              muted={isIntroMuted} // Use the intro-specific muted state
              playsInline
              preload="metadata"
              controls={true}
              onEnded={handleIntroEnd}
              onLoadStart={() => console.log("Intro video loading started")}
              onCanPlay={() => console.log("Intro video can play")}
              onError={(e) => console.log("Intro video error:", e)}
              style={{
                width: isMobile ? "95vw" : "70vw",
                maxWidth: 900,
                borderRadius: 16,
                boxShadow: "0 8px 32px rgba(0,0,0,0.7)",
                background: "#000",
              }}
            />
          </div>
        </div>
      )} */}

      {/* <div style={{ 
        height: isMobile ? "125vh" : "100vh",
        background: "radial-gradient(circle,rgba(0, 0, 0, 1) 0%, rgba(9, 9, 9, 1) 50%, rgba(26, 26, 26, 1) 100%)",
        transition: "all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
        opacity: 1,
        transform: "translateX(0)",
        overflow: "visible", // Change from hidden to visible
        // When transitioning out:
        // opacity: 0,
        // transform: "translateX(-100%)",
      }}>
        <ElementFinder /> 
      </div> */}


      {/* <div style={{ 
        height: "100vh", // Changed from 50% to 100vh for full viewport height
        backgroundColor: "transparent",
        background: "radial-gradient(circle,rgba(0, 0, 0, 1) 0%, rgba(9, 9, 9, 1) 50%, rgba(26, 26, 26, 1) 100%)",
        transition: "all 0.5s ease-in-out", // Add smooth transition
        opacity: 1, // Full opacity
        transform: "translateY(0)", // No vertical shift
        scrollBehavior: "smooth", // Smooth scrolling
        position: "relative", // For stacking context
        zIndex: 1, // Ensure proper stacking
        overflow: "visible", // Change from hidden to visible
        width: "100vw",
      }}>
        <AboutPage />
      </div> */}
      {/* <LandingpageTray> */}

      <div className="welcome-section" style={{
        position: "relative",
        width: "100%",
        minHeight: welcomeSectionMetrics.minHeight,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: `${welcomeSectionMetrics.marginTop} 0 0 0`,
        paddingTop: welcomeSectionMetrics.paddingTop,
        paddingBottom: welcomeSectionMetrics.paddingBottom,
        overflow: "hidden",
        zIndex: 3,
        background: `
          linear-gradient(180deg, rgba(23, 19, 38, 0) 0%, rgba(23, 19, 38, 0.84) 28%, #171326 62%),
          radial-gradient(70% 120% at 50% 0%, rgba(114, 82, 181, 0.18) 0%, rgba(23, 19, 38, 0) 60%)
        `,
      }}>
        {/* Welcome background text */}
        {/* <span className="welcome-background-text gradient-text" style={{
          position: "absolute",
          top: isMobile ? "17%" : "15%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "150px",
          fontWeight: 800,
          lineHeight: "150px",
          opacity: 0.38,
          zIndex: 0,
          letterSpacing: "0",
          fontFamily: "'DMSans', sans-serif",
          userSelect: "none",
          pointerEvents: "none",
          whiteSpace: "nowrap",
          paddingLeft: "15px",
          maxWidth: "100vw",
          overflow: "hidden",
          textOverflow: "clip",
        }}>
          {t('mainPage.welcome')}
        </span> */}
        <div style={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}>
          <div
              className="welcome-profile-heading"
              ref={(el) => {
                elementRegionRef.current = el;
                headingRef.current = el;
              }}
              style={{
                position: "relative",
                transform: "none",
                textAlign: "center",
                zIndex: 1002,
                maxWidth: isMobile
                  ? "94vw"
                  : `${Math.max(560, Math.round(920 * heroContentScale))}px`,
                width: "100%",
                margin: "0 auto",
                boxSizing: "border-box",
                padding: isMobile
                  ? "0 10px"
                  : desktopViewportScale < 0.9
                  ? "0 16px"
                  : "0 20px",
              }}
            >

              <h1
                style={{
                  margin: 0,
                  marginBottom: isMobile ? "10px" : `${Math.max(8, Math.round(14 * heroContentScale))}px`,
                  color: "#ddae7a",
                  fontFamily: '"Cinzel", "Times New Roman", serif',
                  fontSize: isMobile ? "clamp(1.85rem, 9.2vw, 2.2rem)" : `${Math.max(22, Math.round(38 * heroContentScale))}px`,
                  lineHeight: isMobile ? "1.08" : `${Math.max(24, Math.round(38 * heroContentScale))}px`,
                  textTransform: "uppercase",
                  textShadow: "0 4px 28px rgba(0,0,0,0.45)",
                  fontWeight: 400,
                }}
              >
                {t('mainPage.exploretitle')}
              </h1>

              {/* <div className="subHeading"
                style={{
                  ...styles.subtitle,
                  marginTop: "4px",
                  marginBottom: "12px",
                  color: "#ECE4D5",
                  fontSize: isMobile ? "1.05rem" : "2rem",
                  textAlign: "center",
                  width: "100%",
                  maxWidth: "100%",
                  boxSizing: "border-box",
                  fontStyle: "normal",
                  textShadow: "none",
                }}>
                <span style={{ color: "#DFBD69", fontWeight: "bold" }}>"EXPLORE"</span> instead of find your destiny
              </div> */}

              {/* Modified Date Picker - removed the Check Element button */}
              <div style={{
                marginTop: isMobile ? "4px" : `${Math.max(2, Math.round(4 * desktopViewportScale))}px`,
                marginBottom: isMobile ? "20px" : `${Math.max(8, Math.round(14 * heroContentScale))}px`,
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: isMobile ? "10px" : `${Math.max(4, Math.round(7 * heroContentScale))}px`,
                zIndex: 103,
              }}>
                {/* <label style={{
                  color: "#ddae7a",
                  fontFamily: '"PlayfairDisplay", serif',
                  fontSize: isMobile ? "1rem" : "22px",
                  lineHeight: isMobile ? "1rem" : "22px",
                  marginBottom: "6px",
                  fontWeight: 700,
                }}>
                  Select Your Birth Date:
                </label> */}

                <div
                  style={{
                    ...datePickerShellStyles,
                    maxWidth: isMobile ? "min(92vw, 340px)" : datePickerShellStyles.maxWidth,
                  }}
                >
                  <div style={{ ...datePickerSegmentStyles, flex: "1.2 1 0" }}>
                    <select
                      className="hero-date-select"
                      style={selectStyles}
                      value={selectedMonth}
                      onChange={(e) => setSelectedMonth(e.target.value)}
                    >
                      {months.map((m, i) => (
                        <option key={i} value={i + 1} style={selectOptionStyles}>
                          {m}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div style={datePickerDividerStyles} />

                  <div style={{ ...datePickerSegmentStyles, flex: "0.72 1 0" }}>
                    <select
                      className="hero-date-select"
                      style={selectStyles}
                      value={selectedDay}
                      onChange={(e) => setSelectedDay(e.target.value)}
                    >
                      {days.map((d, i) => (
                        <option key={i} value={d} style={selectOptionStyles}>
                          {d}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div style={datePickerDividerStyles} />

                  <div style={{ ...datePickerSegmentStyles, flex: "1 1 0" }}>
                    <select
                      className="hero-date-select"
                      style={selectStyles}
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(e.target.value)}
                    >
                      {years.map((y, i) => (
                        <option key={i} value={y} style={selectOptionStyles}>
                          {y}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Show element result if available */}
                {elementFinderResult && createPortal(
                  <div 
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100vw",
                      height: "100vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 20000,
                      padding: isMobile ? "5px" : "20px",
                      backgroundColor: "rgba(0,0,0,0.78)",
                      backdropFilter: "blur(6px)",
                      WebkitBackdropFilter: "blur(6px)",
                    }}
                    onClick={() => {
                      setElementFinderResult(null);
                      setShowZodiacTooltip(false); // Reset read more button
                    }}
                  >
                    <div 
                      style={{
                        background: "radial-gradient(120% 120% at 50% 0%, rgba(34, 23, 72, 0.92) 0%, rgba(18, 12, 40, 0.96) 56%, #0d0b24 100%) padding-box, linear-gradient(90deg, #C9A84B, #8A5DF4) border-box",
                        borderRadius: "16px",
                        padding: "2rem",
                        maxWidth: isMobile ? "95vw" : "800px",
                        maxHeight: isMobile ? "95vh" : "70vh",
                        width: "100%",
                        color: "#FFCB21",
                        position: "relative",
                        overflow: "auto",
                        border: "1px solid transparent",
                        boxShadow: "0 18px 46px rgba(0,0,0,0.55)",
                        zIndex: 16001,
                      }}
                      onClick={e => e.stopPropagation()} // Prevent closing when clicking inside modal
                    >
                      {/* <button
                        onClick={() => setElementFinderResult(null)}
                        style={{
                          position: "absolute",
                          top: "15px",
                          right: "15px",
                          background: "#FFCB21",
                          color: "#000",
                          border: "none",
                          borderRadius: "50%",
                          width: "35px",
                          height: "35px",
                          fontSize: "18px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "bold",
                        }}
                      >
                        ×
                      </button> */}

                      <div style={{ textAlign: "center", paddingTop: "10px" }}>
                        <h2 style={{
                          color: "#DEAF77",
                          margin: "0 0 1.5rem 0",
                          fontSize: isMobile ? "1.4rem" : "2.2rem",
                          fontWeight: "bold",
                          textShadow: "0 0 14px rgba(222, 175, 119, 0.3)"
                        }}>
                          {t('mainPage.YourElement')}: {elementFinderResult.title}
                        </h2>

                        {/* Move image to the top above About Your Element */}
                        <img
                          src={elementFinderResult.image}
                          alt={elementFinderResult.title}
                          style={{
                            width: isMobile ? "75px" : "150px",
                            height: isMobile ? "75px" : "150px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            border: "2px solid #DFBD69",
                            boxShadow: "0 0 0 4px rgba(223,189,105,0.16), 0 10px 20px rgba(0,0,0,0.35)",
                            marginBottom: "1.5rem"
                          }}
                        />

                        <div style={{
                          flex: 1,
                          textAlign: "left",
                          minWidth: 0,
                          margin: "0 auto",
                          maxWidth: isMobile ? "95vw" : "600px"
                        }}>
                          {/* API Stem Description or fallback to summary */}
                          <div style={{
                            border: "1px solid rgba(223, 189, 105, 0.35)",
                            background: "linear-gradient(180deg, rgba(40, 27, 90, 0.4), rgba(19, 13, 43, 0.72))",
                            borderRadius: "10px",
                            padding: "1rem",
                            marginBottom: "1rem",
                          }}>
                            <h3 style={{
                              color: "#FFCB21",
                              margin: "0 0 0.5rem 0",
                              fontSize: isMobile ? "1rem" : "1.3rem",
                              fontWeight: "bold",
                              textAlign: "center"
                            }}>
                              {t('mainPage.aboutYourElement')}
                            </h3>
                            <div
                              className="element-modal-content"
                              style={{
                                color: "#FFF6D7",
                                fontSize: isMobile ? "0.95rem" : "1.05rem",
                                margin: "0",
                                lineHeight: "1.5",
                                whiteSpace: "pre-wrap",
                                textAlign: "center"
                              }}
                              dangerouslySetInnerHTML={{
                                __html: elementFinderResult.apiStemDescription || elementFinderResult.summary
                              }}
                            />
                          </div>
                        </div>

                        {/* Zodiac info and API Zodiac Description */}
                        {(zodiacName || zodiacSign) && (
                          <div style={{
                            border: "1px solid rgba(223, 189, 105, 0.35)",
                            background: "linear-gradient(180deg, rgba(40, 27, 90, 0.3), rgba(19, 13, 43, 0.62))",
                            borderRadius: "12px",
                            padding: "1rem",
                            marginBottom: "1.5rem"
                          }}>
                            <h3 style={{
                              color: "#FFCB21",
                              margin: "0 0 1rem 0",
                              fontSize: isMobile ? "1rem" : "1.4rem"
                            }}>
                              {t('mainPage.zodiacInsight')}
                            </h3>
                            <div style={{
                              color: "#FFF6D7",
                              fontSize: isMobile ? "1.05rem" : "1.15rem",
                              margin: "0",
                              fontWeight: "bold"
                            }}>
                              {zodiacName} {zodiacSign}
                            </div>
                            {/* Read more link and description */}
                            {showZodiacTooltip ? null : (
                              <span
                                style={{
                                  color: "#FFCB21",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  fontSize: isMobile ? "0.95rem" : "1.05rem",
                                  marginTop: "0.5rem",
                                  display: "inline-block"
                                }}
                                onClick={() => setShowZodiacTooltip(true)}
                              >
                                {t('mainPage.readMore')}
                              </span>
                            )}
                            {showZodiacTooltip && (
                              <div>
                                {/* Show zodiac image only when tooltip is open */}
                                {(() => {
                                  const matchedZodiac = zodiacMappings.find(
                                    z => z.stem.toLowerCase() === (zodiacName || "").toLowerCase()
                                  );
                                  if (matchedZodiac && matchedZodiac.image) {
                                    return (
                                      <img
                                        src={matchedZodiac.image}
                                        alt={matchedZodiac.title}
                                        style={{
                                          width: isMobile ? "60px" : "130px",
                                          height: isMobile ? "60px" : "130px",
                                          borderRadius: "50%",
                                          objectFit: "cover",
                                          margin: "12px auto",
                                          display: "block",
                                          border: "2px solid rgba(223, 189, 105, 0.7)",
                                          boxShadow: "0 0 0 4px rgba(223,189,105,0.14), 0 12px 22px rgba(0,0,0,0.3)"
                                        }}
                                      />
                                    );
                                  }
                                  return null;
                                })()}
                                <div
                                  className="element-modal-content"
                                  style={{
                                    color: "#FFF6D7",
                                    fontSize: isMobile ? "0.95rem" : "1.05rem",
                                    marginTop: "0.5rem",
                                    fontStyle: "italic",
                                    whiteSpace: "pre-wrap",
                                    lineHeight: "1.5"
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: elementFinderResult.apiZodiacDescription ||
                                      zodiacDescriptions[
                                        (zodiacName.charAt(0).toUpperCase() + zodiacName.slice(1).toLowerCase())
                                      ]
                                  }}
                                />
                              </div>
                            )}
                            {/* Add the requested text above the action buttons */}
                            <div style={{
                              width: "100%",
                              textAlign: "center",
                              color: "#FFF6D7",
                              fontSize: isMobile ? "1rem" : "1.2rem",
                              fontWeight: "bold",
                              margin: "2rem 0 1.2rem 0",
                              lineHeight: "1.5"
                            }}>
                              {t('mainPage.startPlanningLife')}<br />
                              {t('mainPage.yourDestinyForecast')}<br />
                              {t('mainPage.yourLuckActivators')}<br />
                              {t('mainPage.yourBlessedAmulets')}
                            </div>
                            {/* Action buttons */}
                            <div
                              style={{
                                display: "flex",
                                flexDirection: isMobile ? "column" : "row",
                                gap: "1rem",
                                justifyContent: "center",
                                alignItems: isMobile ? "center" : "flex-start", // Center buttons on mobile
                                width: "100%",
                              }}
                            >
                              <button
                                className="find-destiny-btn glow-on glow-text"
                                style={{
                                  padding: "12px 26px",
                                  background: "linear-gradient(#1B0E3C, #1B0E3C) padding-box, linear-gradient(90deg, #C9A84B, #8A5DF4) border-box",
                                  color: "#FFFFFF",
                                  border: "1px solid transparent",
                                  borderRadius: "30px",
                                  fontSize: isMobile ? "1rem" : "1.1rem",
                                  cursor: "pointer",
                                  boxShadow: "0 8px 20px rgba(0,0,0,0.32)",
                                  fontWeight: "bold",
                                  marginBottom: isMobile ? "10px" : "0",
                                  width: isMobile ? "80%" : "35%", // Wider on mobile
                                  textAlign: "center",
                                  display: "block",
                                }}
                                onClick={() => navigate("/signup")}
                              >
                                {t('mainPage.startFreeNow')}
                              </button>
                              <button
                                onClick={() => {
                                  setElementFinderResult(null);
                                  setShowZodiacTooltip(false); // Reset read more button
                                }}
                                style={{
                                  padding: "12px 24px",
                                  background: "transparent",
                                  color: "#DFBD69",
                                  border: "1px solid rgba(223, 189, 105, 0.75)",
                                  borderRadius: "30px",
                                  fontSize: isMobile ? "1rem" : "1.1rem",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                  width: isMobile ? "80%" : "35%", // Wider on mobile
                                  textAlign: "center",
                                  display: "block",
                                  transition: "all 0.3s ease"
                                }}
                              >
                                {t('mainPage.close')}
                              </button>
                            </div>
                          </div>
                        )}

                        {/* Action buttons */}
                        {/* <div style={{
                          display: "flex",
                          flexDirection: isMobile ? "column" : "row",
                          gap: "1rem",
                          justifyContent: "center"
                        }}> */}
                          {/* Add the requested text before the action buttons */}
                          {/* <div style={{
                            width: "100%",
                            textAlign: "center",
                            color: "#FFF6D7",
                            fontSize: isMobile ? "1rem" : "1.2rem",
                            fontWeight: "bold",
                            marginBottom: "1.2rem",
                            lineHeight: "1.5"
                          }}>
                            Start planning a better life with…<br />
                            Your Destiny Forecast<br />
                            Your Luck Activators<br />
                            Your Blessed Amulets
                          </div>
                          <button
                            className="find-destiny-btn glow-on glow-text"
                            style={{
                              padding: "12px 26px",
                              background: "black",
                              color: "#FFCB21",
                              border: "2px solid #FFCB21",
                              borderRadius: "30px",
                              fontSize: isMobile ? "16px" : "18px",
                              cursor: "pointer",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                              fontWeight: "bold",
                              marginBottom: isMobile ? "10px" : "0",
                              width: "100%",
                              textAlign: "center",
                            }}
                            onClick={() => navigate("/signup")}
                          >
                            Start FREE now
                          </button>
                          <button
                            onClick={() => {
                              setElementFinderResult(null);
                              setShowZodiacTooltip(false); // Reset read more button
                            }}
                            style={{
                              padding: "12px 24px",
                              background: "transparent",
                              color: "#FFCB21",
                              border: "2px solid #FFCB21",
                              borderRadius: "8px",
                              fontSize: isMobile ? "1rem" : "1.1rem",
                              cursor: "pointer",
                              fontWeight: "bold",
                              transition: "all 0.3s ease"
                            }}
                          >
                            Close
                          </button>
                        </div> */}
                      </div>
                    </div>
                  </div>,
                  document.body
                )}
              </div>

              {/* Modified Find Your Destiny button to include element finding */}
              <div
                style={{
                  marginTop: isMobile ? "20px" : `${Math.max(10, Math.round(16 * heroContentScale))}px`,
                  marginBottom: isMobile
                    ? "64px"
                    : isCompactDesktop
                    ? `${Math.max(100, Math.round(130 * heroContentScale))}px`
                    : `${Math.max(68, Math.round(78 * heroContentScale))}px`,
                }}
              >
                <button
                  className="find-destiny-btn"
                  onClick={handleFindYourDestiny}
                  style={{
                    //padding: isMobile ? "12px 28px" : "14px 44px",
                    background: "#deaf77",
                    color: "#1b0e3c",
                    border: "none",
                    borderRadius: "500px",
                    fontSize: isMobile ? "1rem" : `${Math.max(14, Math.round(17 * heroContentScale))}px`,
                    cursor: "pointer",
                    //boxShadow: "0 7px 20px rgba(0,0,0,0.35)",
                    fontWeight: 600,
                    lineHeight: isMobile ? "18px" : `${Math.max(14, Math.round(18 * heroContentScale))}px`,
                    width: isMobile
                      ? "min(86vw, 320px)"
                      : `${Math.max(190, Math.round(240 * heroContentScale))}px`,
                    height: isMobile
                      ? "48px"
                      : `${Math.max(42, Math.round(48 * heroContentScale))}px`,
                    textAlign: "center",
                    fontFamily: '"DMSans", serif',
                  }}
                >
                  {t('mainPage.explorebutton')}
                </button>
              </div>
            </div>
          {/* <OurServices /> */}
        </div>
      </div>

      <LandingpageTray className="landingpage-tray">
        {/* Colored column container with three rows for future content */}
        <div className="landingpage-column" style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          justifyContent: 'flex-start',
          gap: isMobile ? '12px' : '20px',
          padding: isMobile ? '12px' : '24px',
          // background: 'linear-gradient(180deg, rgba(72,43,231,0.12), rgba(223,189,105,0.06))',
          borderRadius: 12,
          width: '100%',
          boxSizing: 'border-box',
          marginTop: 0,
          background: "transparent",
        }}>
          <div
            className="landingpage-row landingpage-row-1"
            style={{
              minHeight: isMobile ? "auto" : 120,
              padding: isMobile ? "28px 14px 18px" : "44px 32px 26px",
              position: "relative",
              overflow: "hidden",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: isMobile ? "2px" : "6px",
              borderRadius: isMobile ? "20px" : "28px",
              // background: "radial-gradient(120% 120% at 50% 0%, rgba(34, 23, 72, 0.82) 0%, rgba(18, 12, 40, 0.95) 56%, #0d0b24 100%)",
              // border: "1px solid rgba(236, 195, 117, 0.34)",
              // boxShadow: "0 26px 70px rgba(2, 2, 12, 0.45)",
            }}
          >
            <div style={{ width: "100%", maxWidth: "1040px", margin: "0 auto" }}>
              <div
                style={{
                  position: "relative",
                  width: "fit-content",
                  margin: "0 auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <h2
                  style={{
                    color: "#deaf77",
                    fontSize: isMobile ? "2.9rem" : "40px",
                    margin: "0",
                    textAlign: "center",
                    width: "100%",
                    fontFamily: "'PlayfairDisplay', sans-serif",
                    fontWeight: 800,
                    lineHeight: "40px",
                  }}
                >
                  {amuSectionTitle}
                </h2>
                <img
                  src={shoop}
                  alt="decorative flourish"
                  aria-hidden="true"
                  style={{
                    position: "absolute",
                    right: isMobile ? "-8px" : "-18px",
                    top: isMobile ? "-8px" : "-14px",
                    width: isMobile ? "44px" : "126px",
                    height: "auto",
                    objectFit: "contain",
                    pointerEvents: "none",
                  }}
                />
              </div>

              <p
                style={{
                  color: "#ffffff",
                  fontFamily: '"DMSans", sans-serif',
                  fontSize: isMobile ? "0.9rem" : "18px",
                  lineHeight: "24px",
                  fontStyle: "italic",
                  textAlign: "center",
                  maxWidth: isMobile ? "96%" : "1000px",
                  margin: isMobile ? "8px auto 0" : "10px auto 0",
                  marginTop: "30px"
                }}
              >
                {amuSectionDescriptionLine1}
              </p>

              <p
                style={{
                  color: "#ddae7a",
                  fontSize: isMobile ? "0.95rem" : "20px",
                  lineHeight: "30px",
                  fontFamily: '"DMSans", sans-serif',
                  fontWeight: 500,
                  fontStyle: "italic",
                  textAlign: "center",
                  margin: isMobile ? "16px auto 0" : "18px auto 0",
                }}
              >
                {amuSectionDescriptionLine2}
              </p>

              <div
                style={{
                  marginTop: isMobile ? "14px" : "22px",
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: isMobile ? "10px" : "12px",
                }}
              >
                <button
                  onClick={handleCollectAmuletClick}
                  style={{
                    background: "#deaf77",
                    color: "#200d3c",
                    borderRadius: "10px",
                    height: isMobile ? "46px" : "50px",
                    minWidth: isMobile ? "86%" : "300px",
                    fontWeight: 700,
                    fontSize: isMobile ? "0.95rem" : "18px",
                    lineHeight: "18px", 
                    cursor: "pointer",
                    fontFamily: '"DMSans", sans-serif',
                  }}
                >
                  {t('mainPage.collectyouramulet')}
                </button>
                <button
                  onClick={() => navigate("/shop")}
                  style={{
                    border: "1px solid rgba(255, 199, 44, 0.4)",
                    background: "#0a031e",
                    color: "#f8f5fe",
                    borderRadius: "10px",
                    height: isMobile ? "46px" : "50px",
                    minWidth: isMobile ? "86%" : "300px",
                    fontWeight: 700,
                    fontSize: isMobile ? "0.95rem" : "1.03rem",
                    cursor: "pointer",
                    fontFamily: '"DMSans", sans-serif',
                  }}
                >
                  {t('mainPage.amuletincollection')}
                </button>
              </div>

              <div
                onMouseEnter={() => setIsAmuletSliderHovered(true)}
                onMouseLeave={() => setIsAmuletSliderHovered(false)}
                style={{
                  position: "relative",
                  margin: isMobile ? "20px auto 0" : "28px auto 0",
                  width: "100%",
                  maxWidth: "980px",
                  height: isMobile ? "300px" : "380px",
                  overflow: "hidden",
                  borderRadius: "24px",
                  // background: "radial-gradient(110% 80% at 50% 10%, rgba(83, 48, 126, 0.35) 0%, rgba(15, 10, 34, 0.2) 56%, rgba(15, 10, 34, 0) 100%)",
                }}
              >
                {sliderAmulets.map((amulet, index) => {
                  const imgSrc = typeof amulet === "string" ? amulet : amulet.image;
                  const label = typeof amulet === "string" ? `Amulet ${index + 1}` : amulet.name || `Amulet ${index + 1}`;
                  const cardWidth = isMobile ? 130 : 190;
                  const cardHeight = isMobile ? 198 : 290;
                  return (
                    <div
                      key={amulet.id || index}
                      style={{
                        width: `${cardWidth}px`,
                        height: `${cardHeight}px`,
                        transition: "all 1.2s cubic-bezier(0.4, 0.0, 0.2, 1)",
                        borderRadius: isMobile ? "18px" : "28px",
                        position: "absolute",
                        top: "50%",
                        padding: "1px",
                        background: "linear-gradient(90deg, #C9A84B, #8A5DF4)",
                        boxShadow: "0 18px 46px rgba(0, 0, 0, 0.45)",
                        overflow: "hidden",
                        ...getAmuletStyle(index),
                      }}
                    >
                      <img
                        src={imgSrc}
                        alt={label}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: isMobile ? "17px" : "27px",
                          display: "block",
                        }}
                      />
                    </div>
                  );
                })}
              </div>

              {!isLoggedIn && (
                <div
                  style={{
                    margin: isMobile ? "16px auto 0" : "22px auto 0",
                    width: "100%",
                    maxWidth: "1000px",
                    borderRadius: "16px",
                    border: '1px solid rgba(201, 168, 75, 0.4)',
                    background: "rgba(10, 3, 30, 0.40)",
                    padding: isMobile ? "16px 12px" : "18px 24px 22px",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      color: "#deaf77",
                      fontFamily: "'PlayfairDisplay', sans-serif",
                      fontWeight: 800,
                      fontSize: isMobile ? "2rem" : "18px",
                      lineHeight: "18px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                  >
                    <span
                      style={{
                        color: "#deaf77",
                        fontFamily: "'PlayfairDisplay', sans-serif",
                        fontWeight: 800,
                        fontSize: isMobile ? "2rem" : "18px",
                        lineHeight: "18px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                      }}>
                        {t('mainPage.yourdailyamulet')}
                    </span>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "1px solid rgba(201, 168, 75, 0.85)",
                        borderRadius: "999px",
                        padding: "2px 12px",
                        fontSize: isMobile ? "0.75rem" : "11px",
                        lineHeight: 1,
                        fontWeight: 700,
                        color: "#deaf77",
                        minHeight: isMobile ? "24px" : "20px",
                      }}
                    >
                      {t('mainPage.free')}
                    </span>
                  </div>
                  <div
                    style={{
                      marginTop: "20px",
                      color: "#f8f5fc",
                      fontSize: isMobile ? "0.82rem" : "14px",
                      lineHeight: "14px",
                      fontWeight: 400,
                      marginBottom: isMobile ? "12px" : "25px",
                    }}
                  >
                    {t('mainPage.yourdailyamuletdesc')}
                  </div>
                  <button
                    onClick={handleCollectAmuletClick}
                    style={{
                      marginTop: isMobile ? "12px" : "14px",
                      border: "1px solid transparent",
                      background: "linear-gradient(#1B0E3C, #1B0E3C) padding-box, linear-gradient(90deg, #C9A84B, #8A5DF4) border-box",
                      color: "#fff",
                      borderRadius: "8px",
                      height: isMobile ? "42px" : "50px",
                      padding: "0 20px",
                      fontWeight: 500,
                      fontSize: isMobile ? "0.9rem" : "16px",
                      lineHeight: "16px",
                      cursor: "pointer",
                      fontFamily: '"DMSans", sans-serif',
                    }}
                  >
                    {t('mainPage.yourdailyamuletbutton')} -&gt;
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="landingpage-row landingpage-row-2" style={{
            minHeight: isMobile ? 80 : 120,
            padding: isMobile ? "42px 14px 28px" : "100px 24px 56px",
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            marginBottom: isMobile ? '12px' : '10px',
            width: '100vw',
            marginLeft: 'calc(50% - 50vw)',
            marginRight: 'calc(50% - 50vw)',
            backgroundImage: `linear-gradient(0deg, rgba(8, 6, 28, 0.8), rgba(8, 6, 28, 0.8)), url(${shopbg})`,
            backgroundSize: '100% 100%, 100% 90%',
            backgroundPosition: 'center, center top',
            backgroundRepeat: 'no-repeat, no-repeat',
            WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 15%, black 85%, transparent 100%)',
            maskImage: 'linear-gradient(to bottom, transparent 0%, black 15%, black 85%, transparent 100%)',
            zIndex: 2,
          }}>
            <h2
              className="amuletsTitle"
              style={{
                color: "#deaf77",
                fontSize: isMobile ? "2.15rem" : "36px",
                marginTop: 50,
                marginBottom: isMobile ? "14px" : "18px",
                textAlign: "center",
                width: "100%",
                fontFamily: 'PlayfairDisplay, serif',
                fontWeight: 800,
                lineHeight: "36px",
                textShadow: "0 4px 18px rgba(0,0,0,0.45)"
              }}
              // dangerouslySetInnerHTML={{ __html: siteContent["ECFQE"]?.Title || "<b>Ancient Roots. Modern You.</b>" }}
            >
              {rootsSectionTitle}
            </h2>
            {rootsSectionDescriptionLine1 && (
              <p
                className="amuletDesc"
                style={{
                  color: "#fff",
                  fontSize: isMobile ? "0.9rem" : "15px",
                  fontStyle: "italic",
                  display: 'block',
                  width: isMobile ? "95%" : "74%",
                  margin: '0 auto',
                  textAlign: 'center',
                  fontWeight: 400,
                  whiteSpace: 'normal',
                  overflowWrap: 'anywhere',
                  wordBreak: 'break-word',
                  lineHeight: isMobile ? 1.6 : "24px",
                  maxWidth: "920px",
                  marginBottom: isMobile ? "12px" : "50px",
                }}
                // dangerouslySetInnerHTML={{ __html: siteContent["ECFQE"]?.Description || "Watch Master Siew Li — a trusted spiritual guide with over four decades of practice — share why she created this app for modern seekers like you. Her mission: to make real spiritual wisdom accessible, practical, and empowering… so that anyone, from any background, can improve their life with confidence and clarity." }}
              >
                {rootsSectionDescriptionLine1}
              </p>
            )}
            {rootsSectionSubheading && (
              <h3
                style={{
                  color: "#deaf77",
                  fontSize: isMobile ? "1.8rem" : "26px",
                  marginTop: isMobile ? "8px" : "10px",
                  marginBottom: isMobile ? "8px" : "50px",
                  textAlign: "center",
                  width: "100%",
                  fontFamily: 'PlayfairDisplay, serif',
                  fontWeight: 800,
                  letterSpacing: isMobile ? "0.008em" : "0.012em",
                  lineHeight: "26px",
                  textShadow: "0 4px 18px rgba(0,0,0,0.45)"
                }}
              >
                {rootsSectionSubheading}
              </h3>
            )}
            <p
              className="amuletDesc"
              style={{
                color: "#fff",
                fontSize: isMobile ? "0.9rem" : "16px",
                fontStyle: "italic",
                display: 'block',
                width: isMobile ? "95%" : "74%",
                margin: '0 auto',
                textAlign: 'center',
                fontWeight: 500,
                whiteSpace: 'normal',
                overflowWrap: 'anywhere',
                wordBreak: 'break-word',
                lineHeight: isMobile ? 1.6 : "24px",
                maxWidth: "920px",
                marginBottom: isMobile ? "8px" : "28px",
              }}
            >
              {rootsSectionDescriptionLine2}
            </p>
            <video
              ref={introRef}
              src={introVideo}
              muted={isIntroMuted} // Use the intro-specific muted state
              playsInline
              preload="metadata"
              controls={true}
              onEnded={handleIntroEnd}
              onLoadStart={() => console.log("Intro video loading started")}
              onCanPlay={() => console.log("Intro video can play")}
              onError={(e) => console.log("Intro video error:", e)}
              style={{
                width: isMobile ? "95%" : "68%",
                maxWidth: 980,
                height: 'auto',
                display: 'block',
                margin: isMobile ? '18px auto 0' : '30px auto 0',
                borderRadius: isMobile ? 12 : 16,
                border: '1px solid rgba(223, 179, 102, 0.5)',
                boxShadow: '0 16px 40px rgba(0, 0, 0, 0.45)',
                background: "#000",
                marginBottom: isMobile ? "24px" : "60px",
                zIndex: 101,
              }}
            />
          </div>

          <div className="landingpage-row landingpage-row-3" style={{
            minHeight: isMobile ? 0 : 0,
            // background: 'rgba(255, 255, 255, 0.02)',
            // border: '1px solid rgba(223,189,105,0.08)',
            // borderRadius: 8,
            padding: isMobile ? 0 : 4,
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            marginTop: isMobile ? 0 : 0,
            position: 'relative',
            overflow: 'visible',
            zIndex: 1,
          }}>
            {/* <AboutPage /> */}
            <img
              src={hands}
              alt="Decorative hands"
              style={{
                position: 'absolute',
                left: '50%',
                bottom: isMobile ? '-150px' : '-200px',
                transform: 'translateX(-50%)',
                //width: isMobile ? '72vw' : '560px',
                maxWidth: '90vw',
                height: '830px',
                objectFit: 'contain',
                pointerEvents: 'none',
                zIndex: 0,
                opacity: 0.1,
                filter: 'sepia(0.55) saturate(0.8) brightness(0.78) contrast(0.96) drop-shadow(0 16px 32px rgba(0, 0, 0, 0.45))',
              }}
            />
          </div>
        </div>
      </LandingpageTray>
      <div className="landingpage-row landingpage-row-4" style={{
            minHeight: isMobile ? 80 : 120,
            // background: 'rgba(255, 255, 255, 0.02)',
            // border: '1px solid rgba(223,189,105,0.08)',
            // borderRadius: 8,
            padding: 12,
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            zIndex: 101,
            marginTop: isMobile ? "0px" : isCompactDesktop ? "60px" : "-110px",
          }}>
            {/* Modified Find Your Destiny button to include element finding */}
              <div style={{ marginTop: "20px", marginBottom: isMobile || isCompactDesktop ? "64px" : "40px" }}>
                {/* New content added above the button */}
                <div style={{
                  textAlign: "center",
                  marginBottom: "24px",
                  color: "#FFCB21",
                  fontFamily: "inherit",
                }}>
                  <h2 
                    className="jomhuria-heading"
                    style={{
                      fontFamily: '"Playfair Display", serif',
                      fontWeight: 800,
                      fontSize: "40px",
                      lineHeight: "40px",
                      letterSpacing: "0",
                      textAlign: "center",
                      verticalAlign: "middle",
                      margin: 0,
                      color: "#DEAF77",
                    }}>
                    {t('mainPage.yourFortune')}
                  </h2>
                  <div style={{
                    fontFamily: '"DM Sans", sans-serif',
                    fontWeight: 500,
                    fontStyle: "italic",
                    fontSize: "22px",
                    lineHeight: "24px",
                    letterSpacing: "0",
                    textAlign: "center",
                    margin: "12px 0 18px 0",
                    color: "#FFFFFF",
                  }}>
                    <div dangerouslySetInnerHTML={{ __html: t('mainPage.ready') }} />
                  </div>
                  <div style={{
                    position: "relative",
                    width: isMobile ? "94vw" : "min(92vw, 1120px)",
                    height: isMobile ? "auto" : "320px",
                    margin: isMobile ? "20px auto 0" : "28px auto 0",
                    padding: isMobile ? "24px 14px 30px" : "42px 28px 36px",
                    borderRadius: isMobile ? "22px" : "28px",
                    border: "1px solid rgba(222, 175, 119, 0.38)",
                    backgroundImage: `linear-gradient(180deg, rgba(17, 10, 45, 0.74), rgba(17, 10, 45, 0.82)), url(${clock})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    boxShadow: "0 20px 50px rgba(0, 0, 0, 0.42)",
                    overflow: isMobile ? "visible" : "hidden",
                    marginBottom: "24px",
                    zIndex: 1004,
                  }}>
                    <div style={{
                      textAlign: "center",
                      color: "#DEAF77",
                      fontFamily: '"Playfair Display", serif',
                      fontWeight: 800,
                      fontSize: isMobile ? "30px" : "20px",
                      lineHeight: isMobile ? "32px" : "20px",
                      marginBottom: isMobile ? "18px" : "44px",
                    }}>
                      {t('mainPage.tellMeYourBirthdate')}
                    </div>

                    <div style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "12px"
                    }}>
                    {/* <label style={{
                      color: "#FFCB21",
                      fontSize: isMobile ? "1rem" : "1.2rem",
                      marginBottom: "8px",
                      // backgroundColor: "blue",
                    }}>
                      Select Your Birth Date:
                    </label> */}

                    <div style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      maxWidth: isMobile ? "340px" : "470px",
                      borderRadius: "10px",
                      border: "2px solid transparent",
                      backgroundImage: "linear-gradient(rgba(28, 16, 67, 0.95), rgba(28, 16, 67, 0.95)), linear-gradient(to right, #C9A84B, #8A5DF4)",
                      backgroundOrigin: "border-box",
                      backgroundClip: "padding-box, border-box",
                      padding: isMobile ? "2px 6px" : "4px 8px",
                      zIndex: 20,
                      marginBottom: isMobile ? "12px" : "28px", 
                    }}>
                      <select
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                          color: "#EADDBA",
                          padding: isMobile ? "0.45rem 1.1rem 0.45rem 0.45rem" : "0.5rem 1.2rem 0.5rem 0.55rem",
                          borderRadius: 0,
                          width: "100%",
                          minWidth: 0,
                          fontSize: isMobile ? "0.95rem" : "1.05rem",
                          fontWeight: 600,
                          outline: "none",
                          cursor: "pointer",
                          fontFamily: '"DM Sans", sans-serif',
                          appearance: "none",
                          WebkitAppearance: "none",
                          MozAppearance: "none",
                          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Cpath d='M3 4.5L6 7.5L9 4.5' stroke='%23EADDBA' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "right 0.1rem center",
                          backgroundSize: "12px 12px",
                        }}
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                      >
                        {months.map((m, i) => (
                          <option key={i} value={i + 1} style={selectOptionStyles}>
                            {m}
                          </option>
                        ))}
                      </select>

                      <div style={{ width: "1px", alignSelf: "stretch", background: "rgba(222, 175, 119, 0.45)", margin: "5px 3px" }} />

                      <select
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                          color: "#EADDBA",
                          padding: isMobile ? "0.45rem 1.1rem 0.45rem 0.45rem" : "0.5rem 1.2rem 0.5rem 0.55rem",
                          borderRadius: 0,
                          width: "100%",
                          minWidth: 0,
                          fontSize: isMobile ? "0.95rem" : "1.05rem",
                          fontWeight: 600,
                          outline: "none",
                          cursor: "pointer",
                          fontFamily: '"DM Sans", sans-serif',
                          appearance: "none",
                          WebkitAppearance: "none",
                          MozAppearance: "none",
                          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Cpath d='M3 4.5L6 7.5L9 4.5' stroke='%23EADDBA' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "right 0.1rem center",
                          backgroundSize: "12px 12px",
                        }}
                        value={selectedDay}
                        onChange={(e) => setSelectedDay(e.target.value)}
                      >
                        {days.map((d, i) => (
                          <option key={i} value={d} style={selectOptionStyles}>
                            {d}
                          </option>
                        ))}
                      </select>

                      <div style={{ width: "1px", alignSelf: "stretch", background: "rgba(222, 175, 119, 0.45)", margin: "5px 3px" }} />

                      <select
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                          color: "#EADDBA",
                          padding: isMobile ? "0.45rem 1.1rem 0.45rem 0.45rem" : "0.5rem 1.2rem 0.5rem 0.55rem",
                          borderRadius: 0,
                          width: "100%",
                          minWidth: 0,
                          fontSize: isMobile ? "0.95rem" : "1.05rem",
                          fontWeight: 600,
                          outline: "none",
                          cursor: "pointer",
                          fontFamily: '"DM Sans", sans-serif',
                          appearance: "none",
                          WebkitAppearance: "none",
                          MozAppearance: "none",
                          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Cpath d='M3 4.5L6 7.5L9 4.5' stroke='%23EADDBA' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "right 0.1rem center",
                          backgroundSize: "12px 12px",
                        }}
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                      >
                        {years.map((y, i) => (
                          <option key={i} value={y} style={selectOptionStyles}>
                            {y}
                          </option>
                        ))}
                      </select>
                    </div>

                    <button
                      className="find-destiny-btn"
                      onClick={handleFindYourDestiny2}
                      style={{
                        marginTop: isMobile ? "14px" : "18px",
                        background: "#DEAF77",
                        color: "#1b0e3c",
                        border: "none",
                        borderRadius: "999px",
                        fontSize: isMobile ? "1.05rem" : "22px",
                        fontWeight: 500,
                        lineHeight: "22px",
                        padding: isMobile ? "12px 30px" : "14px 44px",
                        minWidth: isMobile ? "180px" : "260px",
                        cursor: "pointer",
                        fontFamily: '"DM Sans", sans-serif',
                        boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
                      }}
                    >
                      {t('mainPage.startnow')}
                    </button>
                  </div>

                    {/* Show element result if available */}
                    {elementFinderResult_DO_NOT_SHOW && (
                      <div 
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          width: "100vw",
                          height: "100vh",
                          display: "flex",
                          alignItems: "center", // Vertically center
                          justifyContent: "center", // Horizontally center
                          zIndex: 12000,
                          padding: isMobile ? "5px" : "20px",
                        }}
                        onClick={() => {
                          setElementFinderResult_DO_NOT_SHOW(null);
                          setShowZodiacTooltip2(false); // Reset read more button
                        }}
                      >
                        <div 
                          style={{
                            background: "radial-gradient(circle,rgba(0, 0, 0, 1) 0%, rgba(9, 9, 9, 1) 50%, rgba(26, 26, 26, 1) 100%)",
                            borderRadius: "16px",
                            padding: "2rem",
                            maxWidth: isMobile ? "95vw" : "800px",
                            maxHeight: isMobile ? "95vh" : "60vh",
                            width: "100%",
                            color: "#FFCB21",
                            position: "relative",
                            overflow: "auto",
                            border: "2px solid #FFCB21",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
                            zIndex: 12001,
                          }}
                          onClick={e => e.stopPropagation()}
                        >
                          <div style={{ textAlign: "center", paddingTop: "10px" }}>
                            <h2 style={{
                              color: "#FFCB21",
                              margin: "0 0 1.5rem 0",
                              fontSize: isMobile ? "1.4rem" : "2.2rem",
                              fontWeight: "bold"
                            }}>
                              {t('mainPage.YourElement')}: {elementFinderResult_DO_NOT_SHOW.title}
                            </h2>

                            {/* Move image to the top above About Your Element */}
                            <img
                              src={elementFinderResult_DO_NOT_SHOW.image}
                              alt={elementFinderResult_DO_NOT_SHOW  .title}
                              style={{
                                width: isMobile ? "75px" : "150px",
                                height: isMobile ? "75px" : "150px",
                                borderRadius: "50%",
                                objectFit: "cover",
                                // border: "3px solid #FFCB21",
                                // boxShadow: "0 5px 15px rgba(255, 203, 33, 0.3)",
                                marginBottom: "1.5rem"
                              }}
                            />

                            <div style={{
                              flex: 1,
                              textAlign: "left",
                              minWidth: 0,
                              margin: "0 auto",
                              maxWidth: isMobile ? "95vw" : "600px"
                            }}>
                              {/* API Stem Description or fallback to summary */}
                              <div style={{
                                borderRadius: "10px",
                                padding: "1rem",
                                marginBottom: "1rem",
                              }}>
                                <h3 style={{
                                  color: "#FFCB21",
                                  margin: "0 0 0.5rem 0",
                                  fontSize: isMobile ? "1rem" : "1.3rem",
                                  fontWeight: "bold",
                                  textAlign: "center"
                                }}>
                                  {t('mainPage.aboutYourElement')}
                                </h3>
                                <div
                                  className="element-modal-content"
                                  style={{
                                    color: "#FFF6D7",
                                    fontSize: isMobile ? "0.95rem" : "1.05rem",
                                    margin: "0",
                                    lineHeight: "1.5",
                                    whiteSpace: "pre-wrap",
                                    textAlign: "center"
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: elementFinderResult_DO_NOT_SHOW.apiStemDescription || elementFinderResult_DO_NOT_SHOW.summary
                                  }}
                                />
                              </div>
                            </div>

                            {/* Zodiac info and API Zodiac Description */}
                            {(zodiacName2 || zodiacSign2) && (
                              <div style={{
                                borderRadius: "12px",
                                padding: "1rem",
                                marginBottom: "1.5rem"
                              }}>
                                <h3 style={{
                                  color: "#FFCB21",
                                  margin: "0 0 1rem 0",
                                  fontSize: isMobile ? "1rem" : "1.4rem"
                                }}>
                                  {t('mainPage.zodiacInsight')}:
                                </h3>
                                <div style={{
                                  color: "#FFF6D7",
                                  fontSize: isMobile ? "1.05rem" : "1.15rem",
                                  margin: "0",
                                  fontWeight: "bold"
                                }}>
                                  {zodiacName2} {zodiacSign2}
                                </div>
                                {/* Read more link and description */}
                                {showZodiacTooltip2 ? null : (
                                  <span
                                    style={{
                                      color: "#FFCB21",
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                      fontSize: isMobile ? "0.95rem" : "1.05rem",
                                      marginTop: "0.5rem",
                                      display: "inline-block"
                                    }}
                                    onClick={() => setShowZodiacTooltip2(true)}
                                  >
                                    {t('mainPage.readMore')}
                                  </span>
                                )}
                                {showZodiacTooltip2 && (
                                  <div>
                                    {/* Show zodiac image only when tooltip is open */}
                                    {(() => {
                                      const matchedZodiac = zodiacMappings.find(
                                        z => z.stem.toLowerCase() === (zodiacName2 || "").toLowerCase()
                                      );
                                      if (matchedZodiac && matchedZodiac.image) {
                                        return (
                                          <img
                                            src={matchedZodiac.image}
                                            alt={matchedZodiac.title}
                                            style={{
                                              width: isMobile ? "60px" : "130px",
                                              height: isMobile ? "60px" : "130px",
                                              borderRadius: "50%",
                                              objectFit: "cover",
                                              margin: "12px auto",
                                              display: "block",
                                              boxShadow: "0 2px 8px rgba(255,203,33,0.18)"
                                            }}
                                          />
                                        );
                                      }
                                      return null;
                                    })()}
                                    <div
                                      className="element-modal-content"
                                      style={{
                                        color: "#FFF6D7",
                                        fontSize: isMobile ? "0.95rem" : "1.05rem",
                                        marginTop: "0.5rem",
                                        fontStyle: "italic",
                                        whiteSpace: "pre-wrap",
                                        lineHeight: "1.5"
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: elementFinderResult_DO_NOT_SHOW.apiZodiacDescription ||
                                          zodiacDescriptions[
                                            (zodiacName2.charAt(0).toUpperCase() + zodiacName2.slice(1).toLowerCase())
                                          ]
                                      }}
                                    />
                                  </div>
                                )}
                                {/* Add the requested text above the action buttons */}
                                <div style={{
                                  width: "100%",
                                  textAlign: "center",
                                  color: "#FFF6D7",
                                  fontSize: isMobile ? "1rem" : "1.2rem",
                                  fontWeight: "bold",
                                  margin: "2rem 0 1.2rem 0",
                                  lineHeight: "1.5"
                                }}>
                                  {t('mainPage.startPlanningLife')}<br />
                                  {t('mainPage.yourDestinyForecast')}<br />
                                  {t('mainPage.yourLuckActivators')}<br />
                                  {t('mainPage.yourBlessedAmulets')}
                                </div>
                                {/* Action buttons */}
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: isMobile ? "column" : "row",
                                    gap: "1rem",
                                    justifyContent: "center",
                                    alignItems: isMobile ? "center" : "flex-start", // Center buttons on mobile
                                    width: "100%",
                                  }}
                                >
                                  <button
                                    className="find-destiny-btn glow-on glow-text"
                                    style={{
                                      padding: "12px 26px",
                                      background: "black",
                                      color: "#FFCB21",
                                      border: "2px solid #FFCB21",
                                      borderRadius: "30px",
                                      fontSize: isMobile ? "1rem" : "1.1rem",
                                      cursor: "pointer",
                                      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                                      fontWeight: "bold",
                                      marginBottom: isMobile ? "10px" : "0",
                                      width: isMobile ? "80%" : "35%", // Wider on mobile
                                      textAlign: "center",
                                      display: "block",
                                    }}
                                    onClick={() => navigate("/signup")}
                                  >
                                    {t('mainPage.startFreeNow')}
                                  </button>
                                  <button
                                    onClick={() => {
                                      setElementFinderResult_DO_NOT_SHOW(null);
                                      setShowZodiacTooltip2(false); // Reset read more button
                                    }}
                                    style={{
                                      padding: "12px 24px",
                                      background: "transparent",
                                      color: "#FFCB21",
                                      border: "2px solid #FFCB21",
                                      borderRadius: "30px",
                                      fontSize: isMobile ? "1rem" : "1.1rem",
                                      cursor: "pointer",
                                      fontWeight: "bold",
                                      width: isMobile ? "80%" : "35%", // Wider on mobile
                                      textAlign: "center",
                                      display: "block",
                                      transition: "all 0.3s ease"
                                    }}
                                  >
                                    {t('mainPage.close')}
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
            </div>
          </div>

      {/* <AboutPage /> */}

      <Footer />
    </div>
  );
}

export default MainPage;
